(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7032],{

/***/ 69251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAColourPicker = function SvgAColourPicker(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 9.5 9.2"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.9 5.9H2.7l-.3.9-.3.6c0 .2-.1.4-.1.5v.3c0 .2.1.4.2.5s.4.1.7.1v.5H0v-.5c.2 0 .3-.1.5-.1.1 0 .2-.1.3-.2.1-.1.2-.1.3-.3.1-.1.1-.2.2-.4L4.4 0h.5l2.7 6.8c.3.4.4.8.5 1 .1.3.3.5.4.6.2.2.3.3.5.3.1 0 .3.1.5.1v.5H5.6v-.5c.4 0 .7 0 .9-.1s.2-.2.2-.4v-.4c0-.1 0-.2-.1-.3 0-.1-.1-.2-.1-.4l-.6-1.3zM3 5.3h2.7L4.4 1.8 3 5.3z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAColourPicker);

/***/ }),

/***/ 71784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAlignCenter = function SvgAlignCenter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M45.7 61.8v-4.5c0-.6-.2-1.2-.7-1.6-.4-.5-1-.7-1.6-.7H20.6c-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.6v4.5c0 .6.2 1.1.7 1.6.4.5 1 .6 1.6.6h22.7c.6 0 1.2-.1 1.6-.6.6-.5.8-1 .8-1.6zm4.5-36.6v-4.6c0-.6-.2-1.1-.6-1.6-.5-.4-1-.6-1.6-.6H16c-.6 0-1.1.2-1.6.6-.4.5-.6 1-.6 1.6v4.6c0 .6.2 1.1.6 1.6.5.4 1 .6 1.6.6h32c.6 0 1.1-.2 1.6-.6.4-.5.6-1 .6-1.6zM64 6.9V2.3c0-.6-.2-1.1-.6-1.5-.5-.5-1-.7-1.6-.7H2.3C1.6 0 1.1.3.6.8c-.3.3-.6.8-.6 1.5v4.6c0 .6.3 1.1.6 1.6.5.4 1 .6 1.6.6h59.4c.6 0 1.1-.2 1.6-.6.5-.5.8-1 .8-1.6zm-4.7 36.4v-4.5c0-.6-.1-1.1-.6-1.6s-1-.6-1.6-.6H6.9c-.6 0-1.1.1-1.6.6s-.6 1-.6 1.6v4.5c0 .6.1 1.2.6 1.6.5.5 1 .7 1.6.7h50.2c.6 0 1.1-.2 1.6-.7.5-.3.6-.9.6-1.6z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAlignCenter);

/***/ }),

/***/ 77846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAlignLeft = function SvgAlignLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M.6 26.8c.5.4 1 .6 1.6.6H48c.6 0 1.1-.2 1.6-.6.4-.5.6-1 .6-1.6v-4.6c0-.6-.2-1.1-.6-1.6-.5-.4-1-.6-1.6-.6H2.3c-.6 0-1.1.2-1.6.6-.4.5-.6 1-.6 1.6v4.6c-.1.6.2 1.1.5 1.6zm0-18.3c.5.4 1 .6 1.6.6h59.4c.6 0 1.1-.2 1.6-.6.5-.5.8-1 .8-1.6V2.3c0-.6-.2-1.1-.6-1.5-.5-.5-1-.7-1.6-.7L2.3 0C1.6 0 1.1.3.6.8c-.3.3-.6.8-.6 1.5v4.6c0 .6.3 1.1.6 1.6zM.6 45c.5.5 1 .7 1.6.7H57c.6 0 1.1-.2 1.6-.7.5-.4.6-1 .6-1.6v-4.5c0-.6-.1-1.1-.6-1.6s-1-.6-1.6-.6H2.3c-.6 0-1.1.1-1.6.6-.4.5-.6 1-.6 1.6v4.5c-.1.6.2 1.2.5 1.6zm0 18.4c.5.5 1 .6 1.6.6h41.1c.6 0 1.2-.1 1.6-.6.5-.5.7-1 .7-1.6v-4.5c0-.6-.2-1.2-.7-1.6-.4-.5-1-.7-1.6-.7h-41c-.6 0-1.1.2-1.6.7-.4.3-.7.9-.7 1.5v4.5c0 .7.3 1.2.6 1.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAlignLeft);

/***/ }),

/***/ 13707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAlignRight = function SvgAlignRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M63.3 26.8c-.5.4-1 .6-1.6.6H16c-.6 0-1.1-.2-1.6-.6-.4-.5-.6-1-.6-1.6v-4.6c0-.6.2-1.1.6-1.6.5-.4 1-.6 1.6-.6h45.7c.6 0 1.1.2 1.6.6.4.5.6 1 .6 1.6v4.6c.1.6-.2 1.1-.6 1.6zm0-18.3c-.5.4-1 .6-1.6.6H2.3c-.6 0-1.1-.2-1.6-.6C.3 8 0 7.5 0 6.9V2.3C0 1.7.2 1.2.6.8c.5-.5 1-.8 1.7-.8h59.4c.6 0 1.1.2 1.6.7.4.4.7.9.7 1.6v4.6c0 .6-.3 1.1-.7 1.6zm0 36.5c-.5.5-1 .7-1.6.7H6.9c-.6 0-1.1-.2-1.6-.7-.5-.4-.6-1-.6-1.6v-4.5c0-.6.1-1.1.6-1.6s1-.6 1.6-.6h54.8c.6 0 1.1.1 1.6.6.4.5.6 1 .6 1.6v4.5c.1.6-.2 1.2-.6 1.6zm.7 16.7v-4.5c0-.6-.2-1.2-.6-1.6-.5-.5-1-.7-1.6-.7H20.6c-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.6v4.5c0 .6.2 1.1.7 1.6.4.5 1 .6 1.6.6h41.1c.6 0 1.1-.1 1.6-.6.4-.4.7-.9.7-1.6z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAlignRight);

/***/ }),

/***/ 75651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M34.9 62.4a4.5 4.5 0 0 0 3.6 1.6c1.6 0 2.8-.3 3.7-1.6l7.3-7.2c.9-1.1 1.6-2.2 1.6-3.7 0-1.2-.6-2.7-1.6-3.6L33.8 32l15.8-15.8c1-1.1 1.5-2.2 1.5-3.7 0-1.2-.6-2.7-1.6-3.6l-7.3-7.3C41.3.6 40 0 38.4 0c-1.2 0-2.7.6-3.6 1.6L8.2 28.3c-1 .9-1.6 2.2-1.6 3.6 0 1.6.6 2.7 1.6 3.7l26.7 26.8z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgArrowLeft);

/***/ }),

/***/ 98245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M34.9 62.4a4.5 4.5 0 0 0 3.6 1.6c1.6 0 2.8-.3 3.7-1.6l7.3-7.2c.9-1.1 1.6-2.2 1.6-3.7 0-1.2-.6-2.7-1.6-3.6L33.8 32l15.8-15.8c1-1.1 1.5-2.2 1.5-3.7 0-1.2-.6-2.7-1.6-3.6l-7.3-7.3C41.3.6 40 0 38.4 0c-1.2 0-2.7.6-3.6 1.6L8.2 28.3c-1 .9-1.6 2.2-1.6 3.6 0 1.6.6 2.7 1.6 3.7l26.7 26.8z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgArrow);

/***/ }),

/***/ 258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAudioPause = function SvgAudioPause(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.9 2.1c-4 0-7.9.7-11.4 1.9C11.9 7.4 8 11.7 8 11.7c-4.9 4.9-8 11.2-8 18.2 0 8.3 4.2 15.8 10.9 20.9-1.4 2.7-2.4 5.1-8.3 9.8-.5.4-1.1.9-1 1.2.1.2.8.2 2.6-.2 6.1-1.2 10.7-3.1 15.8-5.9 3.7 1.3 7.7 2 11.9 2C49.7 57.7 64 45.3 64 29.9S49.7 2.1 31.9 2.1zM28.3 40c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2V18c0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2v22zm14.9 0c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2V18c0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2v22z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAudioPause);

/***/ }),

/***/ 42010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAudioPlay = function SvgAudioPlay(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.9 2.1c-4 0-7.9.7-11.4 1.9C11.9 7.4 8 11.7 8 11.7c-4.9 4.9-8 11.2-8 18.2 0 8.3 4.2 15.8 10.9 20.9-1.4 2.7-2.4 5.1-8.3 9.8-.5.4-1.1.9-1 1.2.1.2.8.2 2.6-.2 6.1-1.2 10.7-3.1 15.8-5.9 3.7 1.3 7.7 2 11.9 2C49.7 57.7 64 45.3 64 29.9S49.7 2.1 31.9 2.1zm6.8 47.8c-.2 1.3-1 2.1-2.2 2.3-.6-.1-1.1-.3-1.6-.7L23.3 39.9h-9.2c-1.3-.2-2.1-1-2.3-2.2V24.2c0-1.1.6-1.8 1.7-2.1.2-.1.4-.1.6-.1h9.2l11.6-11.6c.6-.5 1.1-.7 1.6-.7 1.1 0 1.8.6 2.1 1.7.1.2.1.5.1.6v37.9zm8.8-11.3c-.3.2-.6.4-.9.5-.4.2-.7.2-.9.2-1.1 0-1.8-.6-2.1-1.7-.1-.2-.1-.4-.1-.6 0-.8.7-1.7 2.2-2.7.2-.1.3-.2.4-.2.9-.8 1.4-1.9 1.5-3.2-.1-1.6-.9-3-2.6-4-.9-.7-1.4-1.4-1.5-2.1.2-1.3 1-2.1 2.2-2.3.3 0 .6.1.9.2 2.7 1.1 4.5 3.1 5.3 6 .2.7.2 1.5.2 2.2.1 3.5-1.5 6-4.6 7.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAudioPlay);

/***/ }),

/***/ 86894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAwards = function SvgAwards(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M52.2 6.6c0-2.2.1-4.4.1-6.6H11.7c0 2.1 0 4.3.1 6.6H.5v1.9c0 11.2 1.9 23.8 16.3 32.1 2 1.1 4.2 1.9 6.4 2.5 1.9 1.8 4.2 3 6.8 3.4v2.9C30 55.3 25.3 60 19.5 60h-2.8v4h30.5v-4h-2.7C38.7 60 34 55.3 34 49.5v-2.9c2.6-.4 4.9-1.6 6.8-3.4 2.3-.5 4.4-1.3 6.4-2.5 14.3-8.3 16.3-20.9 16.3-32.2V6.6H52.2zm-47.7 4H12c.6 9.4 2.3 18.9 6.8 26.7C7 30.4 4.7 20.4 4.5 10.6zm40.7 26.6c4.5-7.8 6.2-17.3 6.8-26.7h7.5c-.2 9.9-2.5 19.9-14.3 26.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgAwards);

/***/ }),

/***/ 76970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.3 25.7c0-8.1 5.7-15.1 13.6-16.8V3.1C29 1.3 30.6-.1 32.4 0c1.6.1 2.9 1.4 3.1 3.1v5.8c7.9 1.6 13.6 8.6 13.6 16.7V28c0 10.4 1.1 16.5 6 22.4H9.4c4.9-5.8 6-12 6-22.4v-2.3zm25.1 31c-.6 4.6-4.7 7.8-9.3 7.2-3.8-.5-6.7-3.4-7.2-7.2-.1-.5.3-1 .8-1.1h14.7c.5 0 1 .4 1 .9v.2z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBell);

/***/ }),

/***/ 76322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.8 64v-3.3c1.9-.1 3.4-.2 4.5-.5s2-.7 2.7-1.4c.6-.7 1.1-1.6 1.3-2.8.2-1.2.3-2.8.3-4.7V12.8c0-1.9-.1-3.5-.2-4.7-.2-1.2-.5-2.1-1-2.8a4 4 0 0 0-2.2-1.4c-.9-.3-2.2-.5-3.6-.6V0h26.7C38.6 0 45 1.3 49.6 4c4.5 2.7 6.8 6.5 6.8 11.5 0 6.6-4.7 11.2-14.2 14v.3c3 0 5.8.4 8.3 1.3 2.5.9 4.6 2.1 6.3 3.6 1.7 1.6 3 3.4 4 5.5.9 2.1 1.4 4.4 1.4 6.9 0 2.8-.7 5.3-2 7.4-1.4 2.1-3.3 3.9-5.9 5.3-5.1 2.8-11.8 4.2-20.5 4.2h-32zm25.9-36.2c2.5 0 4.7-.2 6.5-.7 1.8-.5 3.4-1.1 4.7-2 2.7-1.8 4-4.7 4-8.6 0-4-1-7-3-8.8-2-1.8-5.2-2.7-9.6-2.7h-5.9c-1 0-1.5.5-1.5 1.4v21.4h4.8zm6.7 31.1c8.9 0 13.4-4 13.4-12.1 0-4.9-1.6-8.5-4.8-10.8-1.7-1.2-3.8-2-6.4-2.5-2.6-.5-5.9-.7-9.7-.7h-4v16.6c0 3.4.9 5.9 2.7 7.3 1.7 1.5 4.6 2.2 8.8 2.2z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBold);

/***/ }),

/***/ 55661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCaptain = function SvgCaptain(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.7 11.5v21.9c0 2.1.3 4.1.8 5.9.5 1.6 1.1 3.1 2 4.4 1.7 2.8 4.1 4.8 5.9 6.2 3.4 2.5 6.8 4.3 8.6 5.2 1.8-.9 5.2-2.7 8.5-5.1l.2-.2c1.7-1.3 4.2-3.4 6-6.3.8-1.4 1.4-2.8 1.9-4.4.5-1.7.7-3.7.7-5.7V11.5c-5.6-2-11.4-2.9-17.3-2.9s-11.7 1-17.3 2.9zM35.3 23l10 .2-8 6.1 2.9 9.6-8.2-5.7-8.2 5.7 2.9-9.6-8-6.1 10-.2 3.3-9.5 3.3 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M56.1 4.5C48.4 1.5 40.3 0 32 0S15.6 1.5 7.9 4.5l-.5.2v29c0 2.9.4 5.6 1.1 8.1.6 2.2 1.6 4.4 2.8 6.3 2.4 3.9 5.6 6.5 8.1 8.4 5 3.7 10 6.2 11.9 7.1h.1s.1 0 .1.1c0 0 .1 0 .1.1l.4.2.4-.2h.1c.1 0 .1 0 .2-.1h.2c2-.9 7.1-3.5 12-7.1 2.3-1.8 5.7-4.7 8.2-8.7 1.2-1.9 2.1-4 2.7-6.2.7-2.4 1-5.1 1-7.9V4.7l-.7-.2zm-3.7 5.4v23.5c0 2.3-.3 4.5-.8 6.5-.5 1.8-1.2 3.6-2.2 5.2-2 3.3-4.8 5.7-6.8 7.2-4.1 3-8.3 5.1-9.9 5.9h-.1s-.1 0-.1.1h-.1l-.4.2-.3-.1h-.3c-1.6-.8-5.8-2.8-9.9-5.9-2-1.6-4.6-3.8-6.7-7-1-1.6-1.8-3.4-2.3-5.2-.6-2.1-.9-4.3-.9-6.7V9.4l.5-.2A56.6 56.6 0 0 1 32 5.5c6.8 0 13.5 1.2 19.9 3.7l.5.2v.5z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCaptain);

/***/ }),

/***/ 88088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M50.9 0H13.1C8.3 0 4.5 3.8 4.5 8.6v39.5c0 4.8 3.9 8.6 8.6 8.6h33.5l13 7.1V8.6C59.5 3.8 55.7 0 50.9 0zm-.2 42.7c-6.2 4.6-12.6 6.2-18.2 6.2-11.3 0-20-6.1-20.1-6.1-1-.7-1.3-2.2-.5-3.2.7-1 2-1.2 3-.7.1 0 .1.1.2.1.7.5 17.2 11.8 33 0 1-.8 2.5-.5 3.2.5.6 1 .4 2.5-.6 3.2z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgChat);

/***/ }),

/***/ 13176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m62.8 14.1-5.7-5.7c-.7-.7-1.7-1.2-2.9-1.2-1 0-2.1.5-2.8 1.2L39.2 20.6 27.6 32l-3.8 3.8-11.2-11.4a4.01 4.01 0 0 0-5.7 0l-5.7 5.7c-.7.7-1.2 1.7-1.2 2.7 0 1.2.5 2.1 1.2 2.9l19.9 19.9c.7.8 1.7 1.2 2.9 1.2 1 0 2.1-.2 2.8-1.2L39 43.4l11.4-11.3 12.2-12.2c.7-.8 1.2-1.7 1.2-2.9.2-1.2-.3-2.2-1-2.9z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCheck);

/***/ }),

/***/ 36025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCollect = function SvgCollect(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.5 4.7c-4.6-.1-8.8 1.7-11.8 4.7-1.6 1.5-2.8 3.4-3.7 5.4-.9-2-2.1-3.8-3.6-5.3-3-3.1-7.2-4.9-11.8-4.9C6.8 4.6-.6 13.2 0 23c1.3 18.1 22 31.5 29.4 35.7 1.6.9 3.6.9 5.2 0C42 54.5 62.7 41.1 64 23c.6-9.7-6.7-18.3-16.5-18.3zM33.7 20.5c.5-2.2 1.6-3.5 3.3-4.1.6-.3 1.3-.3 1.9-.2.6.2 1.2.8 1.9 1.9.8 1.3 1 2.8.6 4.3-.5 2.2-1.6 3.5-3.3 4.1-.6.2-1.2.2-1.7.1-1.5-.3-2.4-1.5-2.7-3.4-.3-.9-.2-1.8 0-2.7zm-7.5-4.3c.4-.3.9-.5 1.5-.5 1.5 0 2.7.9 3.3 2.8.3.7.5 1.5.5 2.4 0 2.3-.7 3.9-2.2 4.8-.5.3-1 .5-1.5.5-1.5 0-2.6-.9-3.4-2.7-.3-.8-.5-1.7-.5-2.5 0-2.3.8-3.9 2.3-4.8zm-9.5 14.5c-.4-.7-.6-1.5-.6-2.4-.2-2.3.4-4 1.9-5 .5-.4 1-.6 1.6-.6 1.5-.1 2.8.8 3.7 2.6.4.8.6 1.6.7 2.5.2 2.2-.5 3.9-1.9 5-.5.4-1.1.6-1.6.6-1.7 0-2.9-.8-3.8-2.7zm26.6 16.5c-.9.7-1.9 1.1-3 1.1-1 0-3-.3-6-.8-1-.2-1.8-.3-2.6-.3-.4 0-2.1.2-5.2.6-1.1.2-2.1.2-3.1.3-2.3 0-3.9-1.3-4.7-3.9-.2-.7-.3-1.4-.3-2.1 0-1.8 1-3.6 3.1-5.5.2-.3.5-.5.7-.6 2-1.8 3.8-3.7 5.2-5.7 1.1-1.5 2.5-2.3 4.3-2.3 1.8 0 3.3.7 4.2 1.9.3.3.5.7.8 1 .3.3.5.6.7.9.2.2.4.5.7.8.3.3.5.5.6.7l.6.6c.3.2.5.4.5.5l.6.6c.3.3.5.4.5.5 0 0 .3.2.6.5l.5.4c2.2 1.8 3.4 3.5 3.6 4.9.1.3.1.7.1 1.2-.1 2-.9 3.5-2.4 4.7zM45 35.1c-.3.1-.6.1-.9.1-2.3 0-3.7-1.2-4.1-3.6-.1-.3-.1-.7-.1-1-.1-2.6.7-4.3 2.4-5.1.5-.3 1-.4 1.5-.4.8 0 1.7.5 2.6 1.5.9 1 1.4 2.3 1.5 3.8.1 2.6-.9 4.2-2.9 4.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCollect);

/***/ }),

/***/ 43750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 2.1c-4 0-7.9.7-11.4 1.9 2.6 1.5 4.4 4.1 4.4 7.3 0 4.7-3.8 8.5-8.5 8.5a8.4 8.4 0 0 1-8.4-8.1c-4.9 4.9-8 11.2-8 18.2 0 8.3 4.2 15.8 10.9 20.9-1.4 2.7-2.4 5.1-8.3 9.8-.5.4-1.1.9-1 1.2.1.2.8.2 2.6-.2 6.1-1.2 10.7-3.1 15.8-5.9 3.7 1.3 7.7 2 11.9 2 17.7 0 32-12.4 32-27.8S49.7 2.1 32 2.1z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComment);

/***/ }),

/***/ 99118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M64 12.5c0-1.2-.6-2.7-1.6-3.6l-7.3-7.3C54.2.6 52.9 0 51.3 0c-1.2 0-2.7.6-3.6 1.6L32 17.3 16.2 1.6C15.3.6 14 0 12.6 0 11 0 9.8.6 8.9 1.6L1.6 8.9C.6 9.8 0 11.1 0 12.5c0 1.6.6 2.7 1.6 3.7L17.3 32 1.6 47.9A5 5 0 0 0 0 51.5c0 1.6.6 2.7 1.6 3.7l7.3 7.2c.9 1.1 2.2 1.6 3.7 1.6 1.2 0 2.7-.3 3.6-1.6L32 46.7l15.8 15.8a4.5 4.5 0 0 0 3.6 1.6c1.6 0 2.8-.3 3.7-1.6l7.3-7.2c.9-1.1 1.6-2.2 1.6-3.7 0-1.2-.6-2.7-1.6-3.6L46.7 32l15.8-15.8c1-1.1 1.5-2.2 1.5-3.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCross);

/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDraw = function SvgDraw(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.2 58.7s2-5.1 6.5-4.9c4.4.1 8.1 1.8 8.6 1.8v-.2l4 .5v.2s5.9 0 8.9.4c1.8.2 11.3 1.5 18.4 2.6 4.7.7 4.5.9 4.5 1.1 0 .2.1.7-4.7.6-7.2-.2-16.5-.6-18.2-.8-3-.3-8.9-1.5-8.9-1.5v.2l-4-.4v-.2c-.5-.1-1.9 3.3-8.5-.1-4.5-2.3-6.6.7-6.6.7zM23.3 4.2C6.8 6.8-1 21.6.1 28.2c1.1 6.6 5.2 11 11.7 9.9 6.6-1.1 10.1.1 10.9 5 1.1 6.6 6.8 10.7 13.4 9.7 21.4-3.4 29.4-16.6 27.6-28.1C60.6 5 43 1 23.3 4.2zm14.4 14.1c2.1 0 .7 5.4.3 6.7-.4 1.3-1.5 2.2-2.7 2.2-4.3-.2-2.9-9.1 2.4-8.9zM25.6 30.5c-.4-2.1.1-4.8 1.6-5.7.7-.4 2.8 2.1 3.3 3.3.4.6.5 1.4.4 2.3-.3 1.7-1.7 2.8-3.2 2.5-1.1-.3-1.9-1.3-2.1-2.4zm18.9 11.1c-.6 2.4-2.2 4.3-4.2 5.3-1.6.8-2.9-.6-4.8-1.1-1.5-.4-3.4.5-4.4-.6a8.27 8.27 0 0 1-1.8-7.5c.4-1.7 2.1-2.5 3.4-3.5 1.9-1.6 3.7-3 6.2-2.4 2.4.6 3.4 2.5 4.4 4.6.6 1.7 1.6 3.3 1.2 5.2zm-.9-12.8c-1.1-.4-1.8-1.7-1.7-3 .1-1.3.8-6.6 2.7-5.9 4.9 1.8 2.9 10.4-1 8.9zm7.7 6.5c-.6 1-1.7 1.6-2.8 1.4-1.4-.3-2.3-1.8-2-3.5.2-.8.6-1.5 1.2-2 1-.9 3.8-2.4 4.3-1.8 1 1.4.5 4.1-.7 5.9z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgDraw);

/***/ }),

/***/ 94329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m62.7 8.2-6.9-6.9a4.53 4.53 0 0 0-6.3 0l-4.3 4.3 13.2 13.2 4.3-4.3c1.7-1.7 1.7-4.5 0-6.3zm-55.1 35 13.2 13.2L55.2 22 41.9 8.8 7.6 43.2zM2.4 55 0 64l9-2.4 8.4-2.2L4.7 46.5 2.4 55z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgEdit);

/***/ }),

/***/ 71647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M42.6 10.6h6V.4C45.7.1 42.8 0 39.8 0c-8.7 0-14.6 5.3-14.6 15v8.4h-9.8v11.4h9.8V64h11.7V34.8h9.9l1.5-11.4H37v-7.3c0-3.2.9-5.5 5.6-5.5z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgFacebook);

/***/ }),

/***/ 27321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zm27.3 35.5c-.1.5-.7.8-1.1.4-1.3-1.1-.3-2.2-.8-2.9-.6-.9-2.7-1.1-3.9-2.5-1.1-1.2-.2-1.5-.7-2.8-.3-.9-2.7-2.1-4.1-2-1.8.2-3.2 1.1-3.1 2.7.1 1.4 5.6.8 5.6 3.9 0 1.2-2.3 2.1-2.6 2.7-.3.7-.5 1.8-1 2.1-.5.3-1.9-.3-2.4 0s-.5 1.6-.9 1.9c-.5.3-3.1.6-3.9 1.7-.8 1-.4 3.7-.9 4.5-.4.8-1.8 2.4-2 3.5-.3 1.6.4 3.5 0 4.6-.9 2.7-6.8 4.1-9.5 2.1-1.5-1.1-.2-3-1.2-4.3-.5-.6-1.1-.7-2.2-2-1-1.4.3-3.1-.5-4.4-1-1.6-7.6-3.5-8.7-5.9-.8-1.9-1-6.4-.4-8.2.4-1.3 2.7-1.9 3.6-2.6.8-.6 1.4-2.2 3.1-2.5 1.4-.2 2.9 1.3 3.6 1.7.7.5 2-.2 3.1.1 1.2.3 5.1 3.8 7 3.8 1.9 0 2.3-2.4 2.1-3.7-.2-1.3-2.4-1.2-3.2-1.7-.8-.6-1.9-2.8-3.2-2.8s-3.7 1.5-5.5 1.7c-1.7.2-2.8-1.1-2.9-2.7-.1-1.7 1.7-2.5 3-3 1.5-.6 7.9-1.1 11.6-3.7 1.1-.8 1-3.8 3.6-5.5 1.8-1.2 4.2-.6 5.6-.9.2 0 .4 0 .6.1 8.6 5.7 13.6 15.9 12.2 26.6zM29.5 4.6c.3 0 .5.1.6.3.8 1.1 1 3.3-.1 3.7-1.3.6-2.5.2-3.1.6-.8.5-.6 2.1-2.8 2.5-1.2.3-3.8-1.3-4.6-1.3s-3 .9-3.4 1.3c-.3.3-.8.4-1.3.4-.6 0-.9-.8-.5-1.2a27 27 0 0 1 15.2-6.3z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgGlobe);

/***/ }),

/***/ 40274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M64 23c-1.3 18.1-22 31.5-29.4 35.7-1.6.9-3.6.9-5.2 0C22 54.5 1.3 41.1 0 23-.6 13.2 6.8 4.6 16.6 4.6c4.6 0 8.8 1.8 11.8 4.9 1.5 1.5 2.7 3.3 3.6 5.3.9-2 2.1-3.9 3.7-5.4 3-3 7.2-4.8 11.8-4.7 9.8 0 17.1 8.6 16.5 18.3z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHeart);

/***/ }),

/***/ 29615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgHero = function SvgHero(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M42.8 0H54v33.8H42.8zM10 0h11.2v33.8H10zm21.9 29.4 5 10.3h15.4L40 49.3 44.5 64l-12.6-8.8L19.3 64l4.4-14.7-12.2-9.6h15.4zm0-11.6 5.6 11.5V0H26.3v29.4z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHero);

/***/ }),

/***/ 69595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgHexagon = function SvgHexagon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M59.6 47.9 32 63.9l-27.7-16V16L32 0l27.6 16z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHexagon);

/***/ }),

/***/ 49136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _style, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgImportImage = function SvgImportImage(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".st0{display:none}")), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M64 .1h-5.6c-3 1.8-8.4 3.8-12.1 3.8-3.7 0-8.7-2-11.7-3.8h-5.1c-3 2-7.8 4-11.7 4-3.9 0-9.1-2.1-12.1-4H.2v5.5C2 8.5 3 11.2 3 14.9c0 3.7-1 6.9-2.8 9.9v14.9C2 42.6 3 45.5 3 49.2S2 55.6.2 58.5V64h5.6c3-1.8 8.4-3.8 12.1-3.8 3.7 0 8.7 2 11.7 3.8h5.1c3-2 7.8-4 11.7-4s9.1 2.1 12.1 4H64v-5.5c-1.8-2.9-2.8-5.6-2.8-9.3 0-3.7 1-6.9 2.8-9.9V24.5c-1.8-2.9-2.8-5.9-2.8-9.6 0-3.7 1-6.4 2.8-9.3V.1zM52.8 52.6H11.4V11.5h41.4v41.1z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M30.5 41.6a11.2 11.2 0 0 1-5.7-14.9c2.5-5.6 9.1-8.2 14.8-5.8a10.18 10.18 0 0 0-2.5 19.4 8 8 0 0 0 3.3.8c-2.9 1.7-6.6 2-9.9.5z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgImportImage);

/***/ }),

/***/ 5447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgInappropriate = function SvgInappropriate(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M27.4 43.4 22.1 7.8V0h19.8v7.8l-5.3 35.5h-9.2zm12.1 12.9a7.7 7.7 0 1 1-15.4 0 7.7 7.7 0 0 1 15.4 0z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgInappropriate);

/***/ }),

/***/ 14386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgItalic = function SvgItalic(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.6 50.1c-.7 2.4-1 4.4-1 5.8 0 1.9.6 3.2 1.8 3.8 1.2.7 3.1 1 5.8 1l-1 3.3H10.6l.9-3.3c1.7 0 3.1-.1 4.2-.4 1.2-.2 2.2-.7 3-1.5.9-.7 1.6-1.7 2.2-3 .6-1.3 1.2-2.9 1.7-5L32.3 14c.8-3 1.2-5.3 1.2-6.8 0-1.7-.6-2.8-1.9-3.3-1.2-.5-3.4-.7-6.4-.7L26.4 0h27l-.9 3.3c-1.8 0-3.4.2-4.6.5-1.2.4-2.3 1-3.2 2-.9 1-1.7 2.4-2.4 4.2-.7 1.8-1.4 4.1-2.1 6.9l-8.6 33.2z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgItalic);

/***/ }),

/***/ 74793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLeagues = function SvgLeagues(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.1 25.2c2.6-1.9 4.3-5 4.3-8.4 0-5.7-4.7-10.4-10.4-10.4S5.6 11.1 5.6 16.8c0 3.8 2.1 7.1 5.2 8.9C4.4 29.7 0 45.7 0 57.3h23.2c-.2-7 1.7-19.9 5.2-25.9-1.7-2.7-3.9-4.9-6.3-6.2zm8.2 32.1H64c0-12.2-4.9-28.6-11.6-32.1a10.4 10.4 0 1 0-11.4.5c-6.3 4-10.7 20-10.7 31.6z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLeagues);

/***/ }),

/***/ 92125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M408 426 256 274l152-151c3-4 5-8 5-13s-2-10-5-13l-48-48c-3-3-8-5-13-5s-9 2-12 5L123 261c-4 4-6 8-6 13s2 10 6 13l212 212c3 4 7 6 12 6s10-2 13-6l48-47c3-4 5-8 5-13s-2-9-5-13z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLeft);

/***/ }),

/***/ 26995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLegend = function SvgLegend(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m38.7 32.4 3.7 12.2L32 37.3l-10.4 7.2 3.6-12.1-10-7.7 12.6-.2 4.2-12 4.2 12 12.6.3zm1.8 15.7c4.9-6 13.3-7.8 20.7-6.6l1.5.2-.9 1.2c-4.7 6.2-13.4 8.2-20.8 6.6l-1.5-.3 1-1.1zm1.9-44.4c5.2 4.2 8.3 11.1 7 17.7l-.3 1.5-1.2-.9c-5.3-3.9-8.9-11.2-7-17.8l.4-1.4 1.1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M63.8 25.1c-1 7.2-6.2 14.6-13.6 16.2l-1.4.3.2-1.4c1.3-7.3 6.4-13.9 13.6-16.2l1.4-.4-.2 1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M56.1 9.2c2.7 6.3 1.9 14-2.3 19.5l-1 1.3-.6-1.5c-2.6-6.4-1.9-14 2.3-19.5l1-1.2.6 1.4zM9.5 9c4.3 5.5 4.9 13.1 2.3 19.5l-.5 1.5-1-1.3C6 23.2 5.2 15.6 7.9 9.2l.6-1.4 1 1.2zM23 49.6c-7.4 1.5-16.1-.4-20.8-6.6l-1-1.2 1.6-.2c7.4-1.2 15.8.6 20.7 6.6l1 1.2-1.5.2z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.1 4.2c1.9 6.6-1.7 13.9-7 17.8l-1.2.9-.3-1.5c-1.3-6.7 1.8-13.6 7-17.7l1.1-.9.4 1.4zM1.4 24.1C8.6 26.4 13.6 33 15 40.3l.3 1.4-1.4-.3C6.5 39.8 1.3 32.4.3 25.2L0 23.7l1.4.4zm29.5 31.8c1-2.2-1.1-1.2-1.5-1-2.3 1.7-5.3 3.7-6.6 4.1l.9.8c.4.3.7.7 1.1 1l.4.4.6-.2c2.4-1 3.6-3.1 5-4.9 0-.1 0-.2.1-.2z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M52.7 54.6c-3.2-2.2-6.5-4.2-10.5-4.5-3.1-.2-6.2-.1-9.3.6-.6.2-1.2.2-1.7 0-3-.7-6.2-.8-9.3-.6-3.9.3-7.3 2.3-10.5 4.5l-1.4 1 1.5.7c3.2 1.4 6.8 1.2 10.1.6 1.8-.3 3.4-1.2 4.9-2 0 0 3.2-1.8 4.7-2.4.3-.1.4-.2.5-.2h.5c.1 0 .2 0 .5.2 1.5.6 4.7 2.4 4.7 2.4 1.6.8 3.1 1.7 4.9 2 3.4.6 7 .8 10.2-.6l1.5-.7-1.3-1z"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M41.2 58.9c-1.3-.3-4.3-2.3-6.6-4.1-.4-.2-2.5-1.1-1.4 1v.1c1.4 1.8 2.6 3.9 5 4.9l.6.2.4-.4c.4-.3.7-.7 1.1-1l.9-.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLegend);

/***/ }),

/***/ 38611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "st0",
    d: "M52.61 28.6h-4.13V15.08l-.01-.28c-.02-.38-.29-3.83-2.36-7.31C43.24 2.66 38.25 0 32.07 0h-.27C20.45 0 15.77 8.85 15.4 14.8v13.8h-4c-1.83 0-3.32 1.49-3.32 3.32v28.75c0 1.83 1.49 3.32 3.32 3.32h41.22c1.83 0 3.32-1.49 3.32-3.32V31.93c-.01-1.84-1.5-3.33-3.33-3.33zM24.35 15.28c.17-1.65 1.21-6.33 7.46-6.33h.27c6.28 0 7.3 4.74 7.46 6.32V28.6H24.35V15.28z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLock);

/***/ }),

/***/ 45945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M52.4 19.5c-4.3-4.6-10.7-7.4-19.9-6.6l-1 .1c-.7-2.8-2.1-5.9-3.8-6.5s-4 .2-5.1.6c-1.6.6-2.8 1.8-4.2 2-1.1.1-2.4.1-3.5 0-2.7 0-5.4.9-7.5 2.8C3 16.2 2.6 27 4.3 34.4c1.3 5.1 3.3 10 5.9 14.6.5.8 1.9 4 2.7 4.3.2.1.4.1.6.1.6-.1 1.4-.2 2.1-.3-1.3-3.4-2-7.1-2.2-10.7-.4-3.6 1.1-4.9 3.1-6 2.9-2.1 4.7-5.4 4.7-9.1v-1.6c0-.6.1-3.1.2-4.2-.7-.2-1.4-.8-1.4-1.6.9-.4 1.6.4 1.9.3.1-.7-1.5-.8-.9-1.9 1 0 .8 1.6 1.7 1.5 0-.6-.9-1.4-.3-1.9.7.2.3 1.8.7 2 .3-.1.1-.5.4-.6.3 0 .7 0 1-.2.1.7.2 1.3-.2 1.7.4.2.1.4.3.8.3.8 1.4 1.5 1.5 2s-.2 1.1-.7 1.3c-.2.1-.4 0-.6 0-.4-.4-.2-1-.8-1-.6 0-.7 1.1-.7 1.9.1 2.8.1 6 .1 9.4 0 2.5-.4 4.3-.6 6.5-.2 2.9-.9 5.8-1 8.3 0 .9 0 1.9.2 2.8l2.9-.2 1.1-.1c.5-.1.6-.3.6-.4-.3-.2-.6-.5-.7-.8-.6-1 .3-2.6.3-2.6.4-.8 1.3-1.6.8-2.4-.1-.4-.4-.7-.8-.9.2-.1.5-.1.7.1.2.3.5.5.9.7.4 0 .7.3.9.7 0 .4 0 .8-.2 1.3-.1.4.2 1.3.2 1.7v1.4c.1.3.3.6.6.7-.2.1-.5.2-.7.1 0 .2.2.4.4.4-.1.1-.3.2-.4.2h4.9c1.4.1 2.9.4 5.4.5V53c-.1-.7.6-.4.7-.8.2-.6-.3-.6-.1-1.3-2.2-.1-3.3 2.6-4.7.3.7-.5 2-.3 2.8-.6-1.5-.8-3.1-1.6-4.8-2.1-.8-3.1 3-1.8 4.1-.7.3-.1-.1-.3 0-.6 3-.9 3.5-4.5 8.6-3.3 3.1.7 3.1 3 5.1 5.3.1.7-.7.2-.7.8.7-.1 1.5-.2 2.2-.2-.7.8-2.5.5-3.5 1-.1.8 1.1.6 1.1 1.4.1 1-.4 1.1-.7 1.7-1.3-.2-1.3-1.5-2-2.1-.8 0-.7 1.3-.9 2.1l6.3.3H57c-2.5-4.9-2.1-14.7.1-20 1.6 1.1 4.2 2.8 6.7 1.6-6.3-4.1-7-11.5-11.4-16.3zm-39.8.6c-1.1 1.1-1.1 2.9 0 4.1.2.2.5.4.8.5-1.7.2-3.2-1-3.4-2.7-.2-1.7 1-3.2 2.7-3.4.9-.1 1.9.2 2.5.8-1-.2-2 .1-2.6.7zm3.6 12.5-.7-.7-.8.7.4-1-.4-.4.5-.1.2-.5.2.5.8.1-.7.4.5 1zm27.4-14.1.3-.6.3.6 1 .1-.8.4.3 1.1-.8-.8-.9.9.4-1.1-.5-.4.7-.2zm-9.4 1 .2-.7.4.6h.7l-.3.5.8 1.1-1.3-.6-.5.5v-.7l-1-.4 1-.3zm-6-2.2.2-.4.2.4h.4l-.3.2.1.5-.4-.3-.5.3v-.5l-.2-.4.5.2zm25.1 11.5-.4.2.1-.5-.7-.6.8.2.2-.9.2.9.5.1-.3.3.3 1-.7-.7z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M41.3 51.5c0 .7.1 1.3.2 2l2 .1c0-.1-.1-.2-.1-.3.1-.8 1.5 0 1.1-1.3-.6-.6-2.2-.3-3.2-.5z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLogo);

/***/ }),

/***/ 90224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLogout2 = function SvgLogout2(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M25.3 7.4c-12.9 4.1-20.1 17.9-16 30.8s17.9 20.1 30.8 16 20.1-17.9 16-30.8a24.57 24.57 0 0 0-30.8-16z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLogout2);

/***/ }),

/***/ 65882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.7 25.5c-2.2 0-4-1.8-4-4V3.6c.1-2.2 2-3.9 4.2-3.7 2 .1 3.6 1.7 3.7 3.7v17.9c.1 2.2-1.7 4-3.9 4z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.7 60.5c-15.6 0-28.2-12.6-28.2-28.2 0-9.2 4.5-17.8 12-23.1a3.9 3.9 0 0 1 5.5 1c1.3 1.8.8 4.3-1 5.5-9.2 6.4-11.4 19-5 28.2s19 11.4 28.2 5 11.4-19 5-28.2c-1.4-2-3.2-3.8-5.2-5.2a4 4 0 0 1-1.1-5.5 4 4 0 0 1 5.5-1.1c12.9 8.7 16.2 26.3 7.5 39.2a27.94 27.94 0 0 1-23.2 12.4z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLogout);

/***/ }),

/***/ 98732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M33.1 40.9c-.3.2-.7.3-1.1.3s-.7-.1-1.1-.3L0 22.7v21.1c0 3.9 3.1 7 7 7h50c3.9 0 7-3.1 7-7V22.7L33.1 40.9z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 36.6 63.6 18c-.9-2.8-3.5-4.8-6.6-4.8H7c-3.1 0-5.7 2-6.6 4.8L32 36.6z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMail);

/***/ }),

/***/ 25177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 5.338c-2.2 0-4 1.9-4 4.3s1.8 4.3 4 4.3h56c2.2 0 4-1.9 4-4.3s-1.8-4.3-4-4.3H4zm0 22.4c-2.2 0-4 1.9-4 4.3s1.8 4.3 4 4.3h56c2.2 0 4-1.9 4-4.3s-1.8-4.3-4-4.3H4zm0 22.3c-2.2 0-4 1.9-4 4.3s1.8 4.3 4 4.3h56c2.2 0 4-1.9 4-4.3s-1.8-4.3-4-4.3H4z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMenu);

/***/ }),

/***/ 68260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M62.4 23c-.8-.8-2.3-1.5-3.7-1.4H5.2c-1.5.1-2.6.5-3.7 1.6C.6 24 0 25.5.1 26.8v10.3a4.97 4.97 0 0 0 5.2 5.3h53.5c1.5-.1 2.6-.5 3.7-1.6.8-.8 1.5-2.3 1.4-3.7V26.9c.1-1.4-.4-2.7-1.5-3.9z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMinus);

/***/ }),

/***/ 59029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 6.7,
    cy: 32,
    r: 6.7
  })), _circle2 || (_circle2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 6.7
  })), _circle3 || (_circle3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 57.3,
    cy: 32,
    r: 6.7
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMore);

/***/ }),

/***/ 73945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMusic = function SvgMusic(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120.001,
    viewBox: "0 0 120 120.001"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5482",
    d: "M114.285 79.844a24.152 24.152 0 0 0-.873-3.668q-.138-.426-.287-.834a22.71 22.71 0 0 0-7.592-10.349c-.32-.233-.5-.348-.5-.348l-3.733-7.644h-3.9v-.091a.354.354 0 0 1 0 .091l1.352-.107s-6.058-43.9-45.968-39.268c0 0-.407.041-1.132.153a38.715 38.715 0 0 0-5.784 1.267C33.9 22.361 10.845 32.978 13.444 65.301l-.049.015-2.879.859-.5 4.125-.564 4.628-.042.073v.005l-.111.224-.006.013c-.1.2-.236.5-.4.879l-.007.015A44 44 0 0 0 5.52 89.493v.034a41.55 41.55 0 0 0 .089 8.458c1.491 13.022 10.457 17.932 13.446 19.216 1.644.705 5.74-.4 9.095-1.535l.179.093a10.881 10.881 0 0 0 .924.411c.178.07.376.143.592.218.294.1.634.2.994.3q.424.114.906.215a16.128 16.128 0 0 0 2.633.34c.379.018.758.022 1.156.013a16.94 16.94 0 0 0 1.343-.091c.372-.039.751-.09 1.139-.158.065-.011.13-.026.195-.038q.537-.1 1.091-.241c.068-.018.134-.032.2-.051.4-.108.815-.237 1.231-.381.092-.032.183-.066.274-.1.432-.157.868-.329 1.311-.53a18.82 18.82 0 0 0 1.662-.863c.28-.161.554-.33.825-.5.171-.11.343-.219.51-.334.287-.2.571-.4.848-.619.059-.046.121-.088.18-.134.178-.141.346-.294.519-.441l.242-.208c.14-.123.285-.242.422-.37.206-.191.4-.4.6-.6.171-.173.344-.343.508-.524.187-.2.364-.42.543-.633.163-.195.328-.389.485-.592s.33-.445.491-.672.307-.432.454-.656.3-.47.441-.71.284-.477.419-.723.264-.493.392-.746.257-.522.38-.79a23.476 23.476 0 0 0 .681-1.641 24.251 24.251 0 0 0 .586-1.745c.084-.278.167-.556.243-.841.089-.332.168-.672.247-1.013.066-.286.133-.569.192-.862.074-.362.135-.736.2-1.109.047-.288.1-.572.141-.866.057-.4.1-.818.144-1.232.03-.282.067-.557.091-.844.04-.47.063-.955.088-1.44.008-.169.024-.332.03-.5a14.3 14.3 0 0 0 2.567-5.169c1.352-4.7 1.921-6.262 1.921-6.262l8.869.272-1.459 4.602s-2.775-2.064-5.835.854c-2.451 2.337-1.61 5.179.722 6.692h-.005l2.03 1.35v-.01a6.475 6.475 0 0 0 2.233 1.031c2 .5 3.477-.653 4.561-2.472a23.371 23.371 0 0 0 4.129 7.524 18.62 18.62 0 0 0 3.244 3.052q.459.336.918.631l.1.062q.41.259.815.488l.162.09q.372.206.739.385l.206.1c.229.108.455.21.68.305l.231.1c.216.088.428.169.639.247.078.028.157.06.234.087.211.074.417.141.621.205.07.022.143.048.213.069a17.344 17.344 0 0 0 4.328.743h.621a17.905 17.905 0 0 0 3.389-.419c.488-.1 1.009-.235 1.558-.4l.181-.054c.15-.046.3-.1.454-.146.091-.03.183-.062.275-.094.148-.052.3-.1.446-.16q.32-.118.643-.254c.131-.054.263-.114.395-.173s.254-.114.383-.174.264-.126.4-.192.284-.146.427-.222a17.97 17.97 0 0 0 1.062-.61c.121-.075.241-.156.361-.235.144-.1.288-.192.431-.293.122-.086.245-.172.366-.263.167-.123.332-.254.5-.386s.315-.258.471-.393l.11-.095c.187.019.375.037.565.05h.05c.274.018.55.026.827.028h.206c.295 0 .591-.012.889-.034h.047c.279-.022.559-.057.838-.1l.227-.035c.3-.05.592-.108.888-.182a9.074 9.074 0 0 0 3.69-1.96q.276-.237.542-.5a12.9 12.9 0 0 0 1.02-1.118c3.738-4.6 5.473-12.644 4.281-20.191M41.307 24.212a29.9 29.9 0 0 1 19.657 1.984c-5.2 1.921-11.257 4.166-11.257 4.166s-3.531 1.6-2.25 6.191c1.095 3.924 2.658 11.51 3.088 13.629a9.735 9.735 0 0 0-2.586.819c-2.615.537-6.091 2.188-5.411 7.22.757 5.609 6.407 6.639 10.252 4.7a7.011 7.011 0 0 0 5.626-4.5c1.766-5.764-2.041-17.379-2.041-17.379L67.4 36.233l1.722 7.237-.092.041c-.909.2-7.96 1.926-7.161 8.519.854 7.044 8.752 5.657 10.247 4.59l.014-.011a5.953 5.953 0 0 0 2.26-.748 10.2 10.2 0 0 0 3.629-9.606c-.354-2.034-1.367-5.864-2.433-9.652 5.857 6.423 8.684 14.6 9.9 19.256a6.718 6.718 0 0 0-1.976 1.683c-1.186 1.4-2.6 3.227-3.6 4.531a17.088 17.088 0 0 0-2.1.941 3.383 3.383 0 0 0-3.568-.509 4.294 4.294 0 0 0-1.835 5.02l.034.1a18.262 18.262 0 0 0-2.6 5.03c-3.7-.037-11.325.019-11.325.019a2.525 2.525 0 0 0-2.846 1.993c-.422 1.3-1.422 4.5-2.254 7.183a29.032 29.032 0 0 0-4.491-8.781q-.312-.41-.638-.8l-.017-.021q-.319-.384-.652-.752l-.034-.037q-.323-.357-.658-.7l-.06-.06q-.325-.327-.661-.637l-.087-.079q-.323-.3-.657-.577l-.122-.1a19.723 19.723 0 0 0-1.444-1.088c-.066-.045-.133-.088-.2-.132-.205-.136-.412-.27-.621-.4-.08-.049-.161-.094-.241-.142-.2-.117-.4-.232-.6-.341a7.04 7.04 0 0 0-.287-.146c-.192-.1-.385-.2-.581-.287-.111-.052-.224-.1-.336-.148-.185-.08-.369-.161-.555-.235-.128-.05-.258-.094-.387-.141-.175-.064-.35-.13-.528-.188-.146-.048-.294-.088-.441-.131-.164-.048-.327-.1-.493-.142s-.341-.079-.512-.117c-.148-.032-.295-.07-.444-.1-.2-.039-.411-.068-.616-.1-.12-.018-.239-.041-.36-.056q-.492-.062-.993-.092a11.63 11.63 0 0 0-1.071-.011c-.116 0-.228.016-.342.024-.236.014-.472.03-.7.059-.131.016-.259.039-.389.06-.211.033-.422.068-.63.112-.131.028-.261.061-.391.093a10.273 10.273 0 0 0-.974.283 16.009 16.009 0 0 0-.944.354c-.206.087-.41.18-.611.277-.1.047-.2.093-.3.142-.179.091-.356.187-.531.285l-1.437-4.259H24.6s-2.758-27.145 16.7-38.527",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5483",
    d: "M52.079.378S5.061 5.041 8.894 52.718H19.74l.235-16.381S21.146 11.053 52.079.378",
    fill: "#4ac5d3"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5484",
    d: "M88.87 46.413s-2.741-18.278-15.313-28.589S50.785 5.131 39.481 7.611c0 0 3.209-2.91 10.489-5.254s26-2.811 38.9 12.889c0 0 12.42 17.341 12.186 28.355Z",
    fill: "#2b687f"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5485",
    d: "M88.87 46.413s-2.741-18.278-15.313-28.589S50.785 5.131 39.481 7.611c0 0 3.209-2.91 10.489-5.254s26-2.811 38.9 12.889c0 0 12.42 17.341 12.186 28.355Z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5486",
    d: "M21.146 49.901S16.928 8.451 53.485 2.827s47.805 40.074 47.57 40.774l1.484-.118S95.89-4.713 52.079.377C13.76 4.83 18.32 49.901 18.32 49.901",
    fill: "#2b687f"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5487",
    d: "m86.981 46.413 14.074-2.812h4.279l4.1 8.394a24.887 24.887 0 0 1 10.162 16.685c1.82 11.527-2.578 24.116-10.465 26.088s-16.078-4.1-16.078-4.1L82.431 82.33l-1.062-14.257 5.612-14.561Z",
    fill: "#2f6b8e"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5488",
    d: "M109.581 70.045c0 8.942-8.882 24.3-8.9 24.326a16.151 16.151 0 0 0 8.44.4c7.887-1.972 12.286-14.561 10.466-26.088a24.886 24.886 0 0 0-10.163-16.684l-4.1-8.4h-4.279l.639 9.117s7.887 8.378 7.887 17.327",
    fill: "#2b687f"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5489",
    d: "m101.694 52.718 7.735-.722-4.095-8.4h-4.279Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5490",
    d: "M86.223 48.159s-19.111.954-16.684 26.891 21.538 25.026 21.538 25.026 21.993.3 20.021-27-24.875-24.917-24.875-24.917",
    fill: "#4ac5d3"
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5491",
    d: "M89.947 62.932a14.567 14.567 0 0 1 2.111 6.526c.546 5.047.969 9.92-1.784 14.479-6.174 10.224-11.938-2.913-11.332-9.843.117-1.329.655-2.919.458-4.242a.742.742 0 0 1-.859.444 1.146 1.146 0 0 1-.759-.685 2.662 2.662 0 0 1-.178-1.041c-.043-2.869.727-7.043 3.4-8.673a5.971 5.971 0 0 1 5.734.152 8.512 8.512 0 0 1 3.208 2.883",
    fill: "#36a7a8"
  })), _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5493",
    d: "M88.195 64.281s-2.275 3.4-1.669 9.812a17.813 17.813 0 0 0 3.747 9.844c6.177-10.225-2.078-19.656-2.078-19.656",
    fill: "#107f77",
    opacity: 0.4
  })), _path12 || (_path12 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5494",
    d: "M111.109 73.325a6.288 6.288 0 0 0-1.168-2.924 2.821 2.821 0 0 0-3.34-.923c-1.358.725-1.5 2.57-1.6 4.106a25.349 25.349 0 0 1-4 12c-2.2 3.4-6.452 5.149-8.19 8.834a3.588 3.588 0 0 0 .064 3.681 4.619 4.619 0 0 0 1.992 1.518c6.168-1.316 17.584-6.433 16.249-26.292",
    fill: "#36a7a8",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5495",
    d: "M86.566 99.495c.049-.017.1-.027.148-.046-.049-.556-.647-.866-1.158-1.09-6.618-2.902-10.909-8.358-13.527-14.918a1.669 1.669 0 0 0-.61.894c3.491 10.449 10.508 13.983 15.147 15.16",
    fill: "#36a7a8"
  })), _path14 || (_path14 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5497",
    d: "M97.2 51.118a1.228 1.228 0 0 0 0-1.054 24.473 24.473 0 0 0-10.975-1.9 18.159 18.159 0 0 0-11.085 5.368.417.417 0 0 0 .01.149c.1.327.536.378.876.352a22.26 22.26 0 0 0 5.613-1.184c1.927-.691 3.915-1.918 6.038-1.345a17.117 17.117 0 0 1 2.672 1.286c1.819.856 5.813.288 6.853-1.672",
    fill: "#5edcdd"
  })), _path15 || (_path15 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5498",
    d: "M94.264 62.643a2.1 2.1 0 0 1-2.271-.432 8.325 8.325 0 0 1-1.453-1.969 15.884 15.884 0 0 0-4.725-4.8c-.328-.215-.707-.493-.689-.884.047-1.013 2.563-.559 3.035-.373a7.651 7.651 0 0 1 2.385 1.806 13.794 13.794 0 0 1 3.718 6.656",
    fill: "#5edcdd"
  })), _path16 || (_path16 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5499",
    d: "M88.35 86.172a.487.487 0 0 1-.2.44c-.127.115-.273.2-.4.307a1.758 1.758 0 0 1-.347.224 7.177 7.177 0 0 1-1.276.528c-.22.067-.444.123-.669.169-.206.041-.412.045-.614.086a10.3 10.3 0 0 1-3.423.116 5.655 5.655 0 0 1-2.877-1.141 5.855 5.855 0 0 1-1.695-2.726 12.2 12.2 0 0 1-.928-3.694c-.031-.844.342-1.847 1.29-1.211.838.563 1.181 2.258 1.574 3.141a8.946 8.946 0 0 0 1.241 2.178 3.2 3.2 0 0 0 2.131 1.207 16.693 16.693 0 0 0 3.162.234 15.237 15.237 0 0 1 2.463-.2c.241.014.543.1.568.342",
    fill: "#5edcdd"
  })), _path17 || (_path17 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5500",
    d: "M53.849 77.157s-5.234-2.5-7.264 2.656 2.5 6.8 4.452 6.249 4.687-2.968 6.171-8.124 2.109-6.874 2.109-6.874l12.732.391-2.109 6.639s-3.046-2.265-6.405.938-1.094 7.275 2.968 8.285 6.171-4.145 7.187-8.754 3.358-13.9 3.358-13.9.7-2.109-2.421-2.187-13.748 0-13.748 0a2.772 2.772 0 0 0-3.124 2.187c-.86 2.656-3.906 12.5-3.906 12.5",
    fill: "#c1be15"
  })), _path18 || (_path18 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5501",
    d: "m45.34 83.795 2.7 1.777 2.612-4.064Z",
    fill: "#c1be15"
  })), _path19 || (_path19 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5502",
    d: "m61.825 84.715 2.229 1.486-.224-2.014Z",
    fill: "#c1be15"
  })), _path20 || (_path20 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5503",
    d: "m76.427 62.915-2.351-1.565v2.123Z",
    fill: "#c1be15"
  })), _path21 || (_path21 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5504",
    d: "M51.352 75.492s-5.234-2.5-7.264 2.656 2.5 6.8 4.452 6.249 4.687-2.968 6.171-8.124 2.109-6.872 2.109-6.872l12.732.391-2.109 6.639s-3.046-2.265-6.405.938-1.094 7.275 2.968 8.285 6.171-4.145 7.187-8.754S74.551 63 74.551 63a1.557 1.557 0 0 0-.475-1.645 3.173 3.173 0 0 0-1.946-.542c-3.125-.078-13.748 0-13.748 0A2.772 2.772 0 0 0 55.258 63c-.86 2.656-3.906 12.5-3.906 12.5",
    fill: "#f3eb0e"
  })), _path22 || (_path22 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5505",
    d: "M81.323 53.491s-2.43-2.636-4.847-1.347-3.058 5.15-1.129 6.857c3.561 3.145 6.6-1.441 9.433-5.278 2.46-3.334 3.138-2.686 3.138-2.686l4.243 2.574-2.519 3.457s-4.042-1.641-6.151.351-.624 4.44.058 5.273c.882 1.076 5.776 2.11 9.608-4.218A48.8 48.8 0 0 1 98.9 50.43a1.731 1.731 0 0 0-.7-2.27c-1.406-.82-7.616-3.691-7.616-3.691s-1.666-.468-3.94 2.226-5.321 6.8-5.321 6.8",
    fill: "#f13244"
  })), _path23 || (_path23 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5506",
    d: "m73.629 55.157 1.049 2.988 1.422-2.988Z",
    fill: "#f13244"
  })), _path24 || (_path24 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5507",
    d: "m98.16 46.591.914 2.41-1.594 1.643-.762-3.34Z",
    fill: "#f13244"
  })), _path25 || (_path25 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5508",
    d: "m81.605 57.781 1.163 3.62 3.044-2.146Z",
    fill: "#f13244"
  })), _path26 || (_path26 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5509",
    d: "M80.491 50.993s-2.43-2.636-4.847-1.347-3.058 5.15-1.129 6.854c3.561 3.145 6.6-1.441 9.433-5.278 2.46-3.334 3.138-2.686 3.138-2.686l4.243 2.574-2.519 3.457s-4.042-1.641-6.151.351-.624 4.44.058 5.273c.882 1.076 5.776 2.11 9.608-4.218a48.8 48.8 0 0 1 5.741-8.041 1.731 1.731 0 0 0-.7-2.27c-1.406-.82-7.616-3.691-7.616-3.691s-1.664-.47-3.938 2.23-5.321 6.8-5.321 6.8",
    fill: "#ff6f5f"
  })), _path27 || (_path27 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5510",
    d: "M25.036 108.001a17.95 17.95 0 0 0 15.56 0c8.671-3.938 14.06-13.077 13.826-27.137s-9.139-27.418-21.09-28.121-19.216 15.425-19.216 15.425Z",
    fill: "#4ac5d3"
  })), _path28 || (_path28 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5511",
    d: "M48.348 64.666a3.414 3.414 0 0 0-.291-2.986c-.065-.148-.137-.292-.2-.439-3.716-4.879-8.763-8.162-14.523-8.5a14.26 14.26 0 0 0-8.863 2.635c.075.036.15.069.225.1 3.525 1.39 7.7.877 10.942 2.843 1.934 1.174 3.276 3.087 4.858 4.705s3.692 3.038 5.935 2.747a2.53 2.53 0 0 0 1.919-1.1",
    fill: "#5edcdd"
  })), _path29 || (_path29 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5512",
    d: "m21.554 95.301 3.482 12.7a17.949 17.949 0 0 0 15.56 0 21.164 21.164 0 0 0 7.731-5.982 3.586 3.586 0 0 0-.893-2.5c-1.121-1.13-3-.955-4.491-.394-1.423.537-2.9 1.5-4.46 1.429a24.277 24.277 0 0 1-.337-2.632A30.43 30.43 0 0 1 39 94.154a45.523 45.523 0 0 0 .777-7.787 45.45 45.45 0 0 0-2.456-15.4 22.986 22.986 0 0 0-5.692-9.556 15.368 15.368 0 0 0-6.3-3.515l-2.665.438c-2.342.552-3.589 3.276-3.438 5.678s1.313 4.6 2.2 6.84a31.557 31.557 0 0 1 2.186 12.913 53.95 53.95 0 0 1-2.058 11.536",
    fill: "#36a7a8",
    opacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5514",
    d: "m5.68 53.677-1.172 9.608A47.3 47.3 0 0 0 .29 88.593c1.641 14.295 11.483 19.685 14.764 21.091s15.466-3.75 15.466-3.75 9.373-5.858 4.921-31.635c0 0-2.187-10.311-8.28-15.623l-2.968-8.775h-5.872Z",
    fill: "#2b687f"
  })), _path31 || (_path31 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5515",
    d: "M26.067 71.801a19.246 19.246 0 0 0-7.747-11.249V49.901L5.68 53.678l-1.172 9.608A47.3 47.3 0 0 0 .29 88.594c1.64 14.295 11.483 19.685 14.763 21.091 15.857-.547 12.733-30.384 11.014-37.884",
    fill: "#3a87a5"
  })), _path32 || (_path32 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5516",
    d: "M7.455 65.96c-.058.02-.116.041-.175.064-3.979 1.5-5.343 7.792-5.9 11.556-1.29 8.772 1.651 23.37 9.306 24.62s9.258-11.825 7.631-22.284c-.739-4.753-3.431-16.555-10.865-13.956",
    fill: "#2f6b8e"
  })), _path33 || (_path33 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5517",
    d: "M7.455 65.96c-.058.02-.116.041-.175.064-3.979 1.5-5.343 7.792-5.9 11.556-1.29 8.772 1.651 23.37 9.306 24.62s9.258-11.825 7.631-22.284c-.739-4.753-3.431-16.555-10.865-13.956",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5518",
    d: "m7.249 66.809-.169.062c-3.851 1.463-5.171 7.61-5.706 11.286-1.249 8.567 1.6 22.824 9 24.044s8.959-11.548 7.385-21.762c-.715-4.641-3.32-16.167-10.514-13.63",
    fill: "#2f6b8e"
  })), _path35 || (_path35 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5519",
    d: "m18.32 60.551 8.84-1.875-2.968-8.775H18.32Z",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5520",
    d: "M18.32 60.551v-10.65L5.679 53.677l-1.171 9.608c6.327-7.85 13.812-2.734 13.812-2.734",
    fill: "#43aec6"
  })), _path37 || (_path37 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5521",
    d: "M35.441 74.301s-2.187-10.311-8.28-15.623l-2.968-8.777h-5.872L5.68 53.677l-1.172 9.608A46.618 46.618 0 0 0 .059 81.232a14.625 14.625 0 0 1 12.729-6.25c8.593.411 21.242 1.251 23.744 8.955.007.023.015.042.023.065a80.726 80.726 0 0 0-1.114-9.7",
    fill: "#57d2e0",
    opacity: 0.23
  })), _path38 || (_path38 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5522",
    d: "M49.747 36.741s-10.077-.469-8.905 8.2 13 7.381 14.934 1.054-2.241-19.077-2.241-19.077l14.531-6.348 1.951 8.2s-8.9 1.64-7.967 9.373 9.608 6.21 11.248 5.038a11.2 11.2 0 0 0 3.984-10.545c-.938-5.39-6.093-22.262-6.093-22.262s-.924-3.984-6.965-1.758S48.7 14.362 48.7 14.362s-3.876 1.757-2.47 6.8 3.517 15.579 3.517 15.579",
    fill: "#92f49b"
  })), _path39 || (_path39 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5523",
    d: "M52.244 35.909s-10.077-.469-8.9 8.2 12.995 7.381 14.934 1.054-2.241-19.077-2.241-19.077l14.531-6.348 1.951 8.2s-8.9 1.64-7.967 9.373 9.608 6.21 11.248 5.038a11.2 11.2 0 0 0 3.984-10.545c-.938-5.39-6.093-22.262-6.093-22.262s-.924-3.984-6.965-1.758S51.2 13.53 51.2 13.53s-3.876 1.757-2.47 6.8 3.515 15.583 3.515 15.583",
    fill: "#61ec77"
  })), _path40 || (_path40 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 .001h120v120H0z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMusic);

/***/ }),

/***/ 79359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M39.5 55.6H24.4c-.5.1-.9.6-.8 1.1.5 3.8 3.4 6.7 7.2 7.2H33c3.8-.5 6.7-3.4 7.2-7.2.2-.5-.2-1-.7-1.1zm15.3-5.2c-4.9-5.9-6-12-6-22.4l.1-2.3a17 17 0 0 0-8.2-14.6c-.1 0-.1-.1-.2-.1-.4-.2-.7-.4-1.1-.6h-.1a19 19 0 0 0-4-1.4V3.1c-.1-1.7-1.5-3-3.1-3.1h-.5c-1.6.1-3 1.4-3.1 3.1v5.8c-1.4.3-2.8.8-4 1.4h-.1c-.4.2-.7.4-1.1.6-.1 0-.1.1-.2.1-5 3.1-8.2 8.5-8.2 14.6l.1 2.3c0 10.4-1.1 16.5-6 22.4h45.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgNotifications);

/***/ }),

/***/ 18389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgOrbV2 = function SvgOrbV2(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.98,
    height: 66.011,
    viewBox: "0 0 65.98 66.011"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 32.984,
    cy: 32.984,
    transform: "translate(.006 .007)",
    fill: "#fff",
    r: 32.984
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 28",
    d: "M31.372.081A32.983 32.983 0 0 0 .041 34.638 32.984 32.984 0 0 0 34.599 65.97a32.984 32.984 0 0 0 31.326-34.557A32.984 32.984 0 0 0 31.372.081Zm15.375 20.385a21.4 21.4 0 0 1 7.885 15.567 21.474 21.474 0 0 1-20.4 22.5c-.186.009-.367-.006-.553 0a21.544 21.544 0 0 0 11.864-11.744 21.394 21.394 0 0 1-15.567 7.886 21.474 21.474 0 0 1-22.5-20.4c-.009-.186.006-.368 0-.553a21.544 21.544 0 0 0 11.749 11.859 21.4 21.4 0 0 1-7.885-15.567 21.473 21.473 0 0 1 20.4-22.5c.186-.009.367.006.553 0a21.544 21.544 0 0 0-11.868 11.751 21.393 21.393 0 0 1 15.567-7.885 21.473 21.473 0 0 1 22.5 20.4c.009.186-.006.368 0 .553a21.542 21.542 0 0 0-11.745-11.866Z",
    fill: "#b7fffd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 29",
    d: "M47.595 3.417A32.984 32.984 0 0 0 3.416 18.381 32.823 32.823 0 0 0 .025 34.294a36.553 36.553 0 0 1 10.811-21.177 32.187 32.187 0 0 1 20.481-8.775 32.2 32.2 0 0 1 21.241 6.732 36.619 36.619 0 0 1 12.9 20.279l.41-.02c.017-.11.025-.222.04-.332A32.962 32.962 0 0 0 47.595 3.417Z",
    fill: "#e8ffff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 30",
    d: "M62.564 47.596a32.846 32.846 0 0 0 3.394-15.791c-.045-.191-.079-.387-.128-.577l-.411.02a36.62 36.62 0 0 1-10.856 21.443 32.2 32.2 0 0 1-20.482 8.775 32.192 32.192 0 0 1-21.24-6.732A36.529 36.529 0 0 1 .065 34.911a32.967 32.967 0 0 0 18.32 27.655 32.984 32.984 0 0 0 44.179-14.97Z",
    fill: "#86fffd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 32.984,
    cy: 32.984,
    transform: "translate(.006 .007)",
    fill: "none",
    r: 32.984
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#85fffd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 31",
    d: "M20.425 19.265a21.729 21.729 0 0 1 4.313-4.011 21.533 21.533 0 0 1 12.587-7.373c-.183-.032-.358-.082-.542-.11a21.526 21.526 0 0 0-4.639-.189 21.544 21.544 0 0 0-11.719 11.683Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 32",
    d: "M19.225 45.586a21.733 21.733 0 0 1-4.01-4.314 21.527 21.527 0 0 1-7.371-12.584c-.031.183-.082.357-.11.542a21.585 21.585 0 0 0-.189 4.639 21.547 21.547 0 0 0 11.68 11.717Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 33",
    d: "M46.747 20.467a21.7 21.7 0 0 1 4.01 4.313 21.527 21.527 0 0 1 7.371 12.584c.032-.182.082-.357.11-.542a21.585 21.585 0 0 0 .189-4.639 21.542 21.542 0 0 0-11.68-11.716Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 34",
    d: "M45.545 46.787a21.729 21.729 0 0 1-4.313 4.011 21.539 21.539 0 0 1-12.585 7.371c.183.031.358.082.542.109a21.471 21.471 0 0 0 4.64.189 21.542 21.542 0 0 0 11.716-11.68Z"
  })))));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgOrbV2);

/***/ }),

/***/ 73265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgOrb = function SvgOrb(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.4 1.5C5.5 6.8-3.8 24.8 1.5 41.6s23.3 26.2 40.1 20.9 26.2-23.3 20.9-40.1A31.95 31.95 0 0 0 22.4 1.5zm19.4 15.3C52.2 21.6 56.8 34 52 44.4c-2.5 5.3-7 9.3-12.5 11.1l-.5.3c4.6-3.4 7.4-8.3 8.2-13.9-4.8 10.4-17.2 15-27.6 10.2-5.3-2.5-9.3-7-11.1-12.5 0-.1-.1-.4-.1-.5 3.4 4.6 8.3 7.4 13.9 8.2-10.4-4.8-15-17.2-10.2-27.6 2.5-5.3 7-9.4 12.6-11.1l.5-.1c-4.6 3.4-7.6 8.3-8.3 13.9C21.7 12 34.1 7.3 44.5 12.1c5.3 2.5 9.4 7 11.2 12.6 0 .1.1.4.1.5-3.3-4.7-8.4-7.7-14-8.4z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgOrb);

/***/ }),

/***/ 93413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M56.9 24.4h-6.2v-5.7C50.8 8.4 42.3 0 32 0S13.2 8.4 13.2 18.8v5.7H7.1c-.8 0-1.4.6-1.4 1.4v36.7c0 .8.6 1.4 1.4 1.4H57c.8 0 1.4-.6 1.4-1.4V25.9c0-.8-.7-1.5-1.5-1.5zM37.7 53.2c-.9-.7-1.8-1.3-2.8-1.9-1-.6-1.9-1.3-2.9-1.8l-3 1.8c-1 .6-1.9 1.3-2.8 1.9.2-2.5.4-5 .7-7.5-.9-.8-1.8-1.6-2.7-2.5-.9-.8-1.9-1.6-2.9-2.3 2.4-.7 4.9-1.1 7.3-1.6 1-2.3 2.2-4.5 3.4-6.8 1.2 2.2 2.3 4.5 3.3 6.8 2.5.4 4.9 1 7.3 1.6-2 1.6-3.9 3.1-5.7 4.8.4 2.5.6 5 .8 7.5zm5.1-28.8H21.2v-5.7c0-6 4.9-10.8 10.8-10.8 6 0 10.8 4.9 10.8 10.8v5.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPadlock);

/***/ }),

/***/ 83958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6 58a7.6 7.6 0 0 0-5.7-2.2L0 63.5c0 .3.2.5.5.5l7.8-.3c0-2.1-.8-4.2-2.3-5.7zm9.2 0 46.5-46.4c-1-1.9-2.3-3.7-3.9-5.3-1.5-1.5-3.2-2.7-5-3.7L6.3 49.1c2 1.8 7.1 6.8 8.9 8.9zM50.8 1.4c-1.1-.5-2-.9-2.9-1.2L1.3 46.9c1 .2 2 .6 3 1.1L50.8 1.4zM16.3 60c.5 1.2 1 2.7 1.2 3.1L64 16.6c-.3-.8-.7-1.9-1.2-3L16.3 60z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPencil);

/***/ }),

/***/ 29160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPicture = function SvgPicture(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 548,
    height: 438
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M183 128c0 15-6 28-16 38-11 11-24 16-39 16-16 0-28-5-39-16-11-10-16-23-16-38 0-16 5-29 16-39 11-11 23-16 39-16 15 0 28 5 39 16 10 10 16 23 16 39zm292 109v128H73v-55l91-91 46 46 146-147 119 119zm28-201H45c-2 0-4 1-6 3s-3 4-3 6v348c0 2 1 4 3 6s4 3 6 3h458c2 0 4-1 6-3s3-4 3-6V45c0-2-1-4-3-6s-4-3-6-3zm45 9v348c0 12-4 23-13 32s-20 13-32 13H45c-12 0-23-4-32-13S0 405 0 393V45c0-12 4-23 13-32S33 0 45 0h458c12 0 23 4 32 13s13 20 13 32z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPicture);

/***/ }),

/***/ 90455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6.5 56.238c.1 6 5.8 9.6 10.8 6.7l40.1-24.3c2.2-1.3 3.7-3.8 3.7-6.6s-1.5-5.3-3.7-6.6l-40.1-24.4c-5-2.8-10.7.7-10.8 6.7v48.5z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPlay);

/***/ }),

/***/ 97053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M59 21.8H42.4v-17c0-2.7-2.2-4.9-4.9-4.9H26.8a4.9 4.9 0 0 0-4.9 4.9v17h-17A4.9 4.9 0 0 0 0 26.7v10.7c0 2.7 2.2 4.9 4.9 4.9h17V59c0 2.7 2.2 4.9 4.9 4.9h10.7c2.7 0 4.9-2.2 4.9-4.9V42.3H59c2.7 0 4.9-2.2 4.9-4.9V26.7c0-2.7-2.2-4.9-4.9-4.9z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPlus);

/***/ }),

/***/ 58922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.9 22H16V6c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v16zm16-2v26c0 3.3-2.7 6-6 6h-4v6c0 3.3-2.7 6-6 6H16c-3.3 0-6-2.7-6-6v-6H6c-3.3 0-6-2.7-6-6V20c0-3.3 2.7-6 6-6h4v14h43.9V14h4c3.3 0 6 2.7 6 6zm-18 22H18v14h28V42z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPrint);

/***/ }),

/***/ 10965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPro = function SvgPro(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m51.6 21.7 2.1-1.7-2.4-1.4 1.8-2-2.5-1 1.5-2.3-2.7-.6 1.1-2.5-2.7-.1.7-2.6-2.7.3.3-2.7-2.6.7-.1-2.7-2.5 1.1-.6-2.7L38 3 37 .5l-2 1.8L33.7 0 32 2.1 30.3 0l-1.4 2.4-2-1.8-1 2.5-2.3-1.5-.6 2.7-2.5-1.1-.1 2.7-2.6-.7.3 2.7-2.7-.3.7 2.6-2.7.1 1.1 2.5-2.7.6 1.5 2.3-2.5 1 1.8 2-2.4 1.3 2.1 1.7-2.1 1.7 2.4 1.4-1.8 2 2.5 1-1.5 2.3 2.7.6-1.1 2.5 2.7.1-.7 2.6 2.7-.3-.3 2.7 2.6-.7.1 2.7 2.5-1.1.6 2.7 2.3-1.5 1 2.5 2-1.8 1.4 2.4 1.7-2.1 1.7 2.1 1.4-2.4 2 1.8 1-2.5 2.3 1.5.6-2.7 2.5 1.1.1-2.7 2.6.7-.3-2.7 2.7.3-.7-2.6 2.7-.1-1.1-2.5 2.7-.6-1.5-2.3 2.5-1-1.8-2 2.4-1.4-2.2-1.7zm-16.4.5 1.7 5.7-4.9-3.4-4.9 3.4 1.7-5.7-4.8-3.6 6-.1 2-5.7 2 5.7 6 .1-4.8 3.6zm-2.5 23v11.1l7.8 7.7V45.2zm-1.4 0h-7.8V64l7.8-7.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPro);

/***/ }),

/***/ 34962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgReadingLight = function SvgReadingLight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M48.9 0H15.1c-.5 0-.9.3-.9.9v3.3c0 .1 5.5 12.6 5.6 12.7v4.5c-1.9 0-3.4 1.6-3.4 3.5s1.6 3.4 3.4 3.5v30.5c0 2.9 2.3 5.2 5.2 5.2h14c2.9 0 5.2-2.3 5.2-5.2v-42s5.6-12.6 5.6-12.7V.9c0-.6-.4-.9-.9-.9zm-21 46.9 4.3-14.5H21.8L35.7 13l-3.9 14.3h10.3L27.9 46.9z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgReadingLight);

/***/ }),

/***/ 2656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRecruit = function SvgRecruit(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.4 0v64h49.1V0H7.4zm11.8 14.1 1.6-4.7 1.6 4.7 4.9.1-3.9 3 1.4 4.7-4-2.8-4.1 2.8 1.4-4.7-3.9-3 5-.1zM50 51.8H13.9v-2.4H50v2.4zm0-9.9H13.9v-2.4H50v2.4zm0-9.9H13.9v-2.4H50V32zm0-9.8H30.4v-2.4H50v2.4zm0-9.9H30.4V9.9H50v2.4z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRecruit);

/***/ }),

/***/ 5733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.7 28.4h16.4V64H11.7zM8.7 15h19.4v9.2H8.7zM32 10 21.8.1v6.1h-6.1l4.1 4.4h24.4l4-4.4h-6.1V.1zm3.8 18.4h16.4V64H35.8zm0-13.4h19.4v9.2H35.8z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgReferral);

/***/ }),

/***/ 92247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 11.5c5.8 0 11 2.4 14.8 6.3.9.9.9 2.4 0 3.4l-1.6 1.6c-1.5 1.5-.4 4 1.7 4h14.2c1.3 0 2.4-1.1 2.4-2.4V10.1c0-2.1-2.6-3.2-4.1-1.7l-1.2 1.2c-1 1-2.5.9-3.4-.1C48.9 3.7 40.9 0 32 0 17.2 0 4.7 10.1 1.1 23.8c-.4 1.5.7 3 2.3 3h7c1 0 1.9-.7 2.3-1.7A20.5 20.5 0 0 1 32 11.5zm0 40.9c-5.6 0-10.7-2.3-14.4-6-.9-.9-1-2.5 0-3.4l1.9-1.9c1.5-1.5.4-4.1-1.7-4.1H2.9C1.6 37 .5 38.1.5 39.4v14.8c0 2.1 2.6 3.2 4.1 1.7l1.5-1.5c.9-1 2.5-.9 3.4.1 5.8 5.8 13.7 9.3 22.5 9.3 14.8 0 27.3-10.1 30.9-23.8.4-1.5-.7-3-2.3-3h-7c-1 0-1.9.7-2.3 1.7-2.8 8-10.4 13.7-19.3 13.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRefresh);

/***/ }),

/***/ 32941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M389 261 177 49c-3-3-7-5-12-5s-10 2-13 5l-48 48c-3 3-5 8-5 13s2 9 5 13l152 151-152 152c-3 4-5 8-5 13s2 9 5 13l48 47c3 4 8 6 13 6s9-2 12-6l212-212c4-3 6-8 6-13s-2-9-6-13z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRight);

/***/ }),

/***/ 25355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSchool = function SvgSchool(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M51.7 19.7c2.5 1.5 4.9-1.5 7.4 0v-4.9c-2.5-1.5-4.9 1.5-7.4 0v-1.2h-1.2v16.8l-3.7-.8v-7.4L32 9.8 17.2 22.2v7.4L0 33.2v20.9h27.9v-12h9v12.1H64v-21l-12.3-2.6V19.7zM11.1 48H4.9v-6.2h6.2V48zm9.8 0h-6.2v-6.2h6.2V48zM32 28.3c-2.7 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9zM49.2 48H43v-6.2h6.2V48zm3.7-6.2h6.2V48h-6.2v-6.2z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32.4 20.3h-.7v3.6h3.7v-.6h-3z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSchool);

/***/ }),

/***/ 86573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M61.4 53.1 44.6 39.8c3-4.1 4.9-9.2 4.9-14.8C49.5 11.4 38.4.3 24.8.3 11.3.3.1 11.4.1 25s11.1 24.7 24.7 24.7c5.6 0 10.7-1.9 14.8-4.9L53 61.5c3.2 3.4 7.2 2.6 9.2 0 2.1-2.6 2.6-5.2-.8-8.4zm-36.5-11c-9.4 0-17.1-7.7-17.1-17.1 0-9.4 7.7-17.1 17.1-17.1C34.3 7.9 42 15.6 42 25c0 9.4-7.7 17.1-17.1 17.1z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSearch);

/***/ }),

/***/ 4296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M63.8 28.3c-.2-1.2-1.3-2.2-2.5-2.2h-6.2c-1.2 0-2.4-.8-2.8-1.7-.3-.9-.8-3.9.1-4.8l4.4-4.4c.8-.9.9-2.3.1-3.2l-5.1-5c-.9-.8-2.4-.7-3.2.2l-4.4 4.4c-.8.8-2.2 1.2-3.1.8-.9-.4-3.3-2.2-3.3-3.4V2.7c0-1.2-1-2.3-2.1-2.5C35.6.2 34 0 32 0s-3.6.2-3.6.2c-1.2.2-2.1 1.3-2.1 2.5v6.2c0 1.2-.8 2.4-1.7 2.8-.9.3-3.9.8-4.8-.1l-4.4-4.4c-.8-.9-2.3-.9-3.2-.2L7 12.2c-.8.9-.7 2.3.2 3.2l4.3 4.4c.8.9 1.2 2.3.8 3.1-.4.9-2.2 3.3-3.4 3.3H2.7c-1.2 0-2.3 1-2.5 2.2C.2 28.3 0 30 0 32s.2 3.6.2 3.6c.2 1.2 1.3 2.1 2.5 2.1h6.2c1.2 0 2.4.8 2.8 1.7.3.9.8 3.9-.1 4.8l-4.3 4.4c-.9.8-.9 2.3-.2 3.2l5.1 5.1c.9.8 2.4.7 3.2-.1l4.4-4.4c.8-.8 2.3-1.2 3.1-.8.9.4 3.3 2.2 3.3 3.4v6.2c0 1.2 1 2.3 2.2 2.5 0 0 1.7.2 3.6.2 2 0 3.6-.2 3.6-.2 1.2-.2 2.1-1.3 2.1-2.5V55c0-1.2.8-2.4 1.7-2.8.9-.3 3.9-.8 4.8.1l4.4 4.4c.8.8 2.3.9 3.2.1l5.1-5.1c.8-.9.7-2.4-.1-3.2l-4.4-4.4c-.9-.9-1.2-2.3-.8-3.1.4-.9 2.2-3.3 3.4-3.3h6.2c1.2 0 2.3-1 2.5-2.1 0 0 .2-1.7.2-3.6.1-2-.1-3.7-.1-3.7zM32 43.7c-6.5 0-11.7-5.2-11.7-11.7 0-6.5 5.2-11.7 11.7-11.7 6.5 0 11.7 5.3 11.7 11.7 0 6.5-5.2 11.7-11.7 11.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSettings);

/***/ }),

/***/ 93073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle, _path39, _circle2, _path40, _circle3, _path41, _circle4, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSfx = function SvgSfx(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.917,
    height: 120,
    viewBox: "0 0 119.917 120"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5524",
    d: "M87.386 80.983c3.275-.415 9.04-.247 17.648 3.132 0 0-8.236-5.311-11.682-8.926a6.1 6.1 0 0 0 1.92-2.341 54.054 54.054 0 0 1 9.762.041 55.5 55.5 0 0 1-9.22-2.985 6.082 6.082 0 0 0-3.645-5.213 8.466 8.466 0 0 0 1.311-4.526v-.005a8.4 8.4 0 0 0-.109-1.287c-.011-.078-.021-.157-.035-.234a8.7 8.7 0 0 0-.2-.872 54.04 54.04 0 0 1 7.573-5.032s-12.308.271-15.149-1.623 12.038-27.187 16.367-30.569c0 0-16.688 14.468-26.19 19.963a7.19 7.19 0 0 0-3.59 1.023 4.383 4.383 0 0 0-1.25-4.975c-.056-.049-.114-.1-.172-.143a4.37 4.37 0 0 0-.359-.26 4.274 4.274 0 0 0-.573-.311c-.076-.034-.156-.058-.235-.087a4.3 4.3 0 0 0-.531-.165 4.565 4.565 0 0 0-.238-.052 4.229 4.229 0 0 0-1.692.011c-.121.024-.233.074-.35.108a4.622 4.622 0 0 0-.485.15 4.479 4.479 0 0 0-.492.266c-.086.05-.18.088-.263.143a4.515 4.515 0 0 0-.61.5c-.015.014-.033.025-.048.04a4.451 4.451 0 0 0-.992 1.509c-3.7-4.766-7.183-13.333-9.864-25.032v13.8L48.631 19.6s4.869 18.8.946 20.965-17.989-10.486-17.989-10.486 7.439 12.647 6.627 13.864-12.579-4.6-12.579-4.6 7.179 6.7 10.275 11.464a9.468 9.468 0 0 0-.931 5.427c.013.114.033.224.051.337q.062.4.156.8a9.614 9.614 0 0 0 .368 1.183c.026.066.046.134.073.2a9.592 9.592 0 0 0 .492 1.027c.007.014.017.027.024.041a9.838 9.838 0 0 0 .577.9l.12.159.008.01a3.384 3.384 0 0 1-.662.1c-3.111.135-14.608 0-14.608 0l7.709 4.6L2.944 69.78s25.8 2.973 27.426 4.056l-9.738 6.221 10.821-.946.169.032a9.649 9.649 0 0 0-.568 3.243 9.809 9.809 0 0 0 .071 1.1 9.296 9.296 0 0 0 .2 1.122 9.49 9.49 0 0 0 .354 1.165 9.938 9.938 0 0 0 .366.833 9.709 9.709 0 0 0 1.223 1.9c-.018-.014-.039-.024-.057-.038.1.117.2.223.3.335.084.094.166.19.253.28.194.2.4.393.612.578h.005c.067.058.129.119.2.175a9.6 9.6 0 0 0 .891.657l.01.007a9.5 9.5 0 0 0 1.149.636c.053.025.109.044.163.068a9.343 9.343 0 0 0 1 .382 9.55 9.55 0 0 0 1.271.307c.121.022.24.047.362.063a9.456 9.456 0 0 0 6.376-1.348 158.38 158.38 0 0 1 .924 27.166s6.544-19.218 13.216-28.741a11.056 11.056 0 0 0 2.384.421c.374.024.744.028 1.11.015a3.525 3.525 0 0 0-.4.835 3.623 3.623 0 0 0-.146.541 3.219 3.219 0 0 0-.061.61 3.568 3.568 0 0 0 2.847 3.493 3.613 3.613 0 0 0 .718.072 3.5 3.5 0 0 0 .635-.064c.072-.013.14-.03.21-.048a3.648 3.648 0 0 0 .389-.12c.076-.028.153-.055.228-.088a3.718 3.718 0 0 0 .481-.261 3.569 3.569 0 0 0 .142.623l.005.017a3.537 3.537 0 0 0 .235.551l.03.056a3.573 3.573 0 0 0 .3.458l.081.1a3.506 3.506 0 0 0 .334.355c.05.046.105.087.158.13a3.653 3.653 0 0 0 .338.251c.082.052.17.093.256.139a3.414 3.414 0 0 0 .315.156 3.448 3.448 0 0 0 .378.117c.087.024.169.057.257.074a3.589 3.589 0 0 0 .677.068h.012a3.533 3.533 0 0 0 .808-.1c.075-.018.144-.045.217-.068a3.408 3.408 0 0 0 .54-.208c.069-.034.134-.071.2-.109a3.47 3.47 0 0 0 .495-.344c.044-.037.09-.07.132-.109a3.613 3.613 0 0 0 .516-.575 8.485 8.485 0 0 0 1.232.1c.25 0 .5-.016.74-.037 7.789 8.474 17.23 19.1 20.168 23.9 0 0-10.654-24.785-12.557-35.687a3.547 3.547 0 0 0 3.025-3.33",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5525",
    d: "M48.349 7.052s5.124 19.786 1 22.063-18.935-11.031-18.935-11.031 7.829 13.309 6.975 14.59-13.238-4.84-13.238-4.84 10.533 9.822 12.1 14.519 2.277 8.113-1 8.256-15.373 0-15.373 0l8.113 4.839-27.72 4.415s27.154 3.129 28.862 4.268l-10.249 6.548 11.388-1 13.522 2.562s3.7 15.373 2.562 38.147c0 0 11.245-33.023 19.643-35.585 0 0 27.615 28.839 33.166 37.906 0 0-13.238-30.789-13.522-40.184 0 0 6.832-3.558 22.063 2.42 0 0-12.811-8.256-13.807-11.529 0 0 8.113-1 13.807-.285 0 0-12.526-2.7-16.512-7.687s11.957-13.522 11.957-13.522-12.953.285-15.943-1.708 12.669-28.611 17.224-32.17c0 0-26.761 23.2-33.024 23.2S58.489 19.99 53.988.354v14.527Z",
    fill: "#ff760a"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5526",
    d: "M51.054 33.812s3.559-3.889 2.277-12.051l1.709 2.514.569-6.975s3.843 12.526 9.252 14.519-13.689 11.237-13.807 1.993",
    fill: "#f7f77c"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5527",
    d: "M47.353 33.812s-6.69-1.993-8.683-4.7c0 0 3.132 7.4 2.278 9.537s-1.281-.8-1.281-.8l-5.837-2.614 3.7 4.195s11.1 2.638 9.822-5.618",
    fill: "#f7f77c"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5528",
    d: "m34.685 52.744-5.267.854 4.413 1.993-2.562 2.42L16.75 60l21.067 3.42Z",
    fill: "#f7f77c"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5529",
    d: "M46.357 70.679S49.773 84.2 48.919 96.87c0 0 8.683-21.494 12.953-24.625s-15.515-12.811-15.515-1.566",
    fill: "#f7f77c"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5530",
    d: "M72.69 75.376s19.643 25.479 20.21 26.476S80.234 76.8 79.807 69.967s-15.231-2.135-7.117 5.409",
    fill: "#f7f77c"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5531",
    d: "M84.5 68.544s8.4.569 10.533 1.139c0 0-8.256-4.982-9.11-7.687S84.5 68.544 84.5 68.544",
    fill: "#f7f77c"
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5532",
    d: "M72.975 34.473c1.566-.945 16.8-11.763 16.8-11.763s-7.971 14.8-4.7 21.636-9.679 1.708-9.679 1.708Z",
    fill: "#f7f77c"
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5533",
    d: "m92.333 43.919 4.7-.712-5.693 3.7Z",
    fill: "#f7f77c"
  })), _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5534",
    d: "m48.607 67.6-.008-.009a9.857 9.857 0 0 0-.694-.943c-.06-.073-.126-.14-.189-.212-.2-.224-.4-.442-.612-.648-.1-.093-.2-.18-.3-.269-.117-.105-.228-.218-.351-.317.015.018.026.041.041.059a10.167 10.167 0 0 0-14.311 14.317c-.019-.015-.041-.025-.06-.041.1.124.213.234.319.353.088.1.174.2.267.3.206.214.424.416.648.612.072.062.14.129.213.19a10.459 10.459 0 0 0 .941.694l.011.007A10.185 10.185 0 0 0 48.607 67.6",
    fill: "#ff5306"
  })), _path12 || (_path12 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5535",
    d: "M46.457 65.2a10.191 10.191 0 0 1-14.333 14.337A10.192 10.192 0 1 0 46.457 65.2",
    fill: "#e5481a"
  })), _path13 || (_path13 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5536",
    d: "M32.887 76.163A10.186 10.186 0 0 1 48.608 67.6a10.19 10.19 0 1 0-14.086 14.089 10.133 10.133 0 0 1-1.635-5.526",
    fill: "#f97a0a"
  })), _path14 || (_path14 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5537",
    d: "M54.3 44.4a10.2 10.2 0 1 1-10.2-10.194A10.2 10.2 0 0 1 54.3 44.4",
    fill: "#ff5306"
  })), _path15 || (_path15 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5538",
    d: "M36.939 47.435a10.187 10.187 0 0 1 15.722-8.56 10.19 10.19 0 1 0-14.086 14.086 10.134 10.134 0 0 1-1.636-5.526",
    fill: "#ff760a"
  })), _path16 || (_path16 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5539",
    d: "M86.123 78.642a8.959 8.959 0 1 1-8.96-8.96 8.96 8.96 0 0 1 8.96 8.96",
    fill: "#ff5306"
  })), _path17 || (_path17 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5540",
    d: "M95.548 49.745a8.96 8.96 0 1 1-8.961-8.96 8.961 8.961 0 0 1 8.961 8.96",
    fill: "#ff5306"
  })), _path18 || (_path18 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5541",
    d: "M89 41.122a8.946 8.946 0 0 1-7.854 15.728A8.953 8.953 0 1 0 89 41.122",
    fill: "#e5481a"
  })), _path19 || (_path19 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5542",
    d: "M98.045 60.4a6.417 6.417 0 1 1-6.417-6.417 6.417 6.417 0 0 1 6.417 6.417",
    fill: "#ff5306"
  })), _path20 || (_path20 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5543",
    d: "M54.874 78.122a5.1 5.1 0 1 1-5.1-5.1 5.1 5.1 0 0 1 5.1 5.1",
    fill: "#ff5306"
  })), _path21 || (_path21 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5544",
    d: "M50.851 73.143a4.043 4.043 0 1 1-6.141 4.679c-.007.1-.031.2-.031.3a5.1 5.1 0 1 0 6.172-4.979",
    fill: "#e5481a"
  })), _path22 || (_path22 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5545",
    d: "M76.856 68.588a4.043 4.043 0 1 1-6.141 4.679c-.007.1-.031.2-.031.3a5.1 5.1 0 1 0 6.172-4.979",
    fill: "#e5481a"
  })), _path23 || (_path23 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5546",
    d: "M70.81 82.695a3.752 3.752 0 1 1-3.752-3.752 3.752 3.752 0 0 1 3.752 3.752",
    fill: "#ff5306"
  })), _path24 || (_path24 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5547",
    d: "M73.421 28.439a4.7 4.7 0 1 1-4.7-4.7 4.7 4.7 0 0 1 4.7 4.7",
    fill: "#ff5306"
  })), _path25 || (_path25 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5548",
    d: "M72.637 34.311a4.7 4.7 0 1 1-4.7-4.7 4.7 4.7 0 0 1 4.7 4.7",
    fill: "#ff5306"
  })), _path26 || (_path26 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5549",
    d: "M66.038 32.253a4.7 4.7 0 1 1-4.7-4.7 4.7 4.7 0 0 1 4.7 4.7",
    fill: "#ff5306"
  })), _path27 || (_path27 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5550",
    d: "M61.842 29.262a5 5 0 0 1 2.881.914 5 5 0 0 1 8.155-3.883 4.68 4.68 0 0 0-8.848 2.116 4.658 4.658 0 0 0-7.154 5.228 5.017 5.017 0 0 1 4.966-4.375",
    fill: "#ff760a"
  })), _path28 || (_path28 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5551",
    d: "M84.613 36.7a7.649 7.649 0 1 1-7.65-7.649 7.65 7.65 0 0 1 7.65 7.649",
    fill: "#ff5306"
  })), _path29 || (_path29 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5552",
    d: "M58.242 36.928a6.986 6.986 0 1 1-6.986-6.986 6.986 6.986 0 0 1 6.986 6.986",
    fill: "#ff5306"
  })), _path30 || (_path30 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5553",
    d: "M51.255 31.458a6.962 6.962 0 0 1 6.91 6.228 6.97 6.97 0 1 0-13.9-.758 6.8 6.8 0 0 0 .077.758 6.962 6.962 0 0 1 6.909-6.228",
    fill: "#ff760a"
  })), _path31 || (_path31 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5554",
    d: "M76.557 85.339a3.752 3.752 0 1 1-3.752-3.752 3.752 3.752 0 0 1 3.752 3.752",
    fill: "#ff5306"
  })), _path32 || (_path32 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5555",
    d: "M77.271 85.527a9.1 9.1 0 0 1-1.3-.1 3.734 3.734 0 0 1-6.763-1.662 3.736 3.736 0 0 1-5.688-2.277 3.738 3.738 0 0 0 5.58 4.352 3.734 3.734 0 0 0 6.766 1.66 9.1 9.1 0 0 0 1.3.1 8.96 8.96 0 0 0 8.96-8.96c0-.191-.017-.378-.029-.566a8.955 8.955 0 0 1-8.823 7.451",
    fill: "#e5481a"
  })), _path33 || (_path33 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5556",
    d: "M89.154 71.46a3.752 3.752 0 1 1-3.754-3.752 3.752 3.752 0 0 1 3.752 3.752",
    fill: "#ff5306"
  })), _path34 || (_path34 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5557",
    d: "M68.43 44.332a11.716 11.716 0 1 1-11.717-11.717A11.717 11.717 0 0 1 68.43 44.332",
    fill: "#faf78a"
  })), _path35 || (_path35 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5558",
    d: "M68.43 44.332a11.716 11.716 0 1 1-11.717-11.717A11.717 11.717 0 0 1 68.43 44.332Z",
    fill: "none",
    stroke: "#faf78a",
    strokeWidth: 1.517
  })), _path36 || (_path36 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5559",
    d: "M75.121 69.711a11.636 11.636 0 1 1-10.879-12.347 11.636 11.636 0 0 1 10.879 12.347",
    fill: "#faf78a"
  })), _path37 || (_path37 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5560",
    d: "M75.121 69.711a11.636 11.636 0 1 1-10.879-12.347 11.636 11.636 0 0 1 10.879 12.347Z",
    fill: "none",
    stroke: "#faf78a",
    strokeWidth: 1.438
  })), _path38 || (_path38 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5561",
    d: "M59.6 63.861a10.477 10.477 0 1 1-10.48-10.477A10.477 10.477 0 0 1 59.6 63.861",
    fill: "#faf78a"
  })), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    "data-name": "Ellipse 393",
    cx: 10.477,
    cy: 10.477,
    r: 10.477,
    transform: "translate(38.644 53.385)",
    fill: "none",
    stroke: "#faf78a",
    strokeWidth: 1.295
  })), _path39 || (_path39 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5562",
    d: "M49.521 57.682a8.62 8.62 0 1 1-8.62-8.62 8.62 8.62 0 0 1 8.62 8.62",
    fill: "#faf78a"
  })), _circle2 || (_circle2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    "data-name": "Ellipse 394",
    cx: 8.62,
    cy: 8.62,
    r: 8.62,
    transform: "translate(32.281 49.062)",
    fill: "none",
    stroke: "#faf78a",
    strokeWidth: 1.517
  })), _path40 || (_path40 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5563",
    d: "M82.213 42.832a8.62 8.62 0 1 1-8.62-8.62 8.62 8.62 0 0 1 8.62 8.62",
    fill: "#faf78a"
  })), _circle3 || (_circle3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    "data-name": "Ellipse 395",
    cx: 8.62,
    cy: 8.62,
    r: 8.62,
    transform: "translate(64.973 34.212)",
    fill: "none",
    stroke: "#faf78a",
    strokeWidth: 1.517
  })), _path41 || (_path41 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5564",
    d: "M92.547 58.521a13.16 13.16 0 1 1-13.16-13.16 13.16 13.16 0 0 1 13.16 13.16",
    fill: "#faf78a"
  })), _circle4 || (_circle4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    "data-name": "Ellipse 396",
    cx: 13.16,
    cy: 13.16,
    r: 13.16,
    transform: "translate(66.228 45.361)",
    fill: "none",
    stroke: "#faf78a",
    strokeWidth: 1.517
  })), _path42 || (_path42 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5565",
    d: "M81.756 45.585a8.615 8.615 0 0 0-15.242-7.665 11.709 11.709 0 0 0-19.955 12.24c-.295.108-.586.224-.871.354a8.618 8.618 0 1 0-6.331 15.642 12.222 12.222 0 0 0 13.7 7.574 12.26 12.26 0 0 0 22.2-2.72 13.153 13.153 0 1 0 6.5-25.425",
    fill: "#ff7900"
  })), _path43 || (_path43 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5566",
    d: "M78.514 46.76c-.078-.016-.154-.021-.232-.035a10.736 10.736 0 0 1-6.365 20.34 10.742 10.742 0 1 0 6.6-20.305",
    fill: "#fc4f02"
  })), _path44 || (_path44 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5567",
    d: "M73.123 61.492A9.986 9.986 0 0 1 67.672 73.4a7.366 7.366 0 0 0 5.286-12.381c.055.156.117.308.165.469",
    fill: "#fc4f02"
  })), _path45 || (_path45 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5568",
    d: "M63.3 47.058a7.71 7.71 0 0 1 8.656 5.242 5.688 5.688 0 0 0-9.028-5.156c.125-.028.247-.063.375-.085",
    fill: "#fc4f02"
  })), _path46 || (_path46 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5569",
    d: "M64.7 65.391a7.711 7.711 0 0 1-8.255-5.848 5.689 5.689 0 0 0 8.635 5.791c-.126.018-.251.044-.38.057",
    fill: "#faf78a"
  })), _path47 || (_path47 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5570",
    d: "M53.111 57.738a7.712 7.712 0 0 1 1.178-10.048 5.663 5.663 0 0 0-2.849 8.627 5.681 5.681 0 0 0 1.9 1.728c-.077-.1-.159-.2-.232-.307",
    fill: "#faf78a"
  })), _path48 || (_path48 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5571",
    d: "M35.569 58.541a9.238 9.238 0 0 1 11.157-4.731 6.815 6.815 0 0 0-11.338 5.154c.061-.14.113-.283.181-.423",
    fill: "#faf78a"
  })), _path49 || (_path49 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5572",
    d: "M50.363 66.3A11.044 11.044 0 0 1 51.6 51.862a8.147 8.147 0 0 0-.885 14.864c-.115-.142-.237-.277-.347-.427",
    fill: "#faf78a"
  })), _path50 || (_path50 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5573",
    d: "M45.928 46.3A11.7 11.7 0 0 1 64.6 36.873c.439.326.749.809 1.2 1.118.365.249 1.142.39.945-.37a1.272 1.272 0 0 0-.42-.569l-.829-.765-2.165-2a2.568 2.568 0 0 0-.674-.5 14.039 14.039 0 0 0-1.5-.8c-.494-.14-1.315-.507-1.815-.641a8.784 8.784 0 0 0-2.627-.267C50.243 32.087 45 37.861 45 44.332a11.651 11.651 0 0 0 1.646 5.968 11.68 11.68 0 0 1-.718-4.008",
    fill: "#faf78a"
  })), _path51 || (_path51 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5574",
    d: "M49.016 49.691a9.732 9.732 0 0 1 15.449-10.669A9.732 9.732 0 0 0 49.2 51.1a9.88 9.88 0 0 0 1 1.109c.235.224.826.728.769-.005a.786.786 0 0 0-.311-.522 5.523 5.523 0 0 0-.525-.338 2.813 2.813 0 0 1-1.116-1.652",
    fill: "#faf78a"
  })), _path52 || (_path52 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5575",
    d: "M72.283 36.479a8.612 8.612 0 0 1 8.547 7.491c.045.349-.115 1.522.172 1.707a.493.493 0 0 0 .51-.018c.742-.447.7-2.084.7-2.827a8.618 8.618 0 0 0-12.966-7.443c-.633.371-3.173 2.077-2.85 2.993.912.028 1.861-.96 2.711-1.3a8.6 8.6 0 0 1 3.175-.6",
    fill: "#faf78a"
  })), _path53 || (_path53 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5576",
    d: "M80.807 45.39c.051.364.411.59.734.766 4.592 2.5 7.8 6.621 7.8 12.043a13.153 13.153 0 0 1-12.876 13.146 13.13 13.13 0 0 0 16.082-12.824A16.114 16.114 0 0 0 89.22 49.2a4.4 4.4 0 0 0-.664-.775c-.567-.482-1.317-.715-1.926-1.139-1.435-1-3.147-1.4-4.6-2.337a1.277 1.277 0 0 0-.456-.213.433.433 0 0 0-.445.169 1.508 1.508 0 0 0-.094.3c-.035.1-.12.2-.224.184",
    fill: "#faf78a"
  })), _path54 || (_path54 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "Path 5577",
    d: "M33.911 58.977a8.6 8.6 0 0 1 12.1-7.881c.318.141 1.216.845 1-.072a2.037 2.037 0 0 0-.216-.479 6.146 6.146 0 0 1-.526-1.323c-.036-.135.017-.365-.129-.456a.27.27 0 0 0-.141-.026h-.515l.012.513a.24.24 0 0 1-.026.141.217.217 0 0 1-.093.067A2.8 2.8 0 0 1 43.3 49.4a9.4 9.4 0 0 0-2.4-.339 8.614 8.614 0 0 0-4.521 15.95 8.59 8.59 0 0 1-2.469-6.035",
    fill: "#faf78a"
  })), _path55 || (_path55 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h119.917v120H0z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSfx);

/***/ }),

/***/ 18958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M61.7 6c-3.5 1.7-7.4 2.6-11.3 2.6C43 8.6 36.1 5.5 31.2 0c-4.8 5.5-11.8 8.6-19.1 8.6C8.2 8.6 4.3 7.7.8 6-.5 24.7 4.3 40.5 14.7 52c4.6 5.1 10.2 9.2 16.5 12 6.3-2.8 12-7 16.7-12.1C58.4 40.2 63 24.8 61.7 6zM38.9 40.7l-7.6-5.5-7.6 5.5 2.9-9-7.6-5.5h9.4l2.9-9 2.9 9h9.4L36 31.8l2.9 8.9z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgShield);

/***/ }),

/***/ 78545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.8 0c3.6 6.6 7 13.5 10.2 20.3 7.4 1.2 14.8 3 22 4.7-5.9 4.8-11.5 9.5-16.8 14.5.8 7.4 2.8 17 3.4 24.5-2.7-2-6.8-5.3-9.7-7.4-2.8-2-5.7-4-8.7-5.7 0 0-6.4 4.3-8.5 5.7-2.9 2-7.6 5.5-10.3 7.4 1.2-7.5 2.6-16.5 3.5-24.3-2.7-2.4-5.4-4.9-8.3-7.3C5.9 30.1 3 27.8 0 25.5c7.2-2.1 14.5-3.6 21.9-5.1C25 13.6 28.3 6.8 31.8 0z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgStar);

/***/ }),

/***/ 68760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTextColourPicker = function SvgTextColourPicker(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M62.8 0H.1v15.9h3.6c.2-2.4.6-4.4 1.2-6C5.5 8.3 6.4 7 7.5 6.1c1.1-.9 2.6-1.6 4.3-2 1.3-.3 2.7-.5 4.3-.5h2.3c1.7 0 3.2 0 4.3.1h.2c1.1.1 1.9.2 2.4.5.6.2 1 .5 1.2.8.2.3.3.7.3 1.2v44.4c0 1.8-.1 3.3-.4 4.6-.2 1.3-.7 2.3-1.5 3.1-.7.8-1.8 1.4-3.3 1.8-1.4.4-3.3.7-5.6.7V64h32v-3.2c-2.3-.1-4.2-.3-5.6-.7-1.4-.4-2.5-1-3.3-1.8-.7-.8-1.2-1.8-1.5-3.1-.2-1.3-.4-2.8-.4-4.6V6.2c0-.5.1-.9.3-1.2.2-.3.6-.6 1.2-.8.6-.2 1.4-.4 2.4-.5h.2c1.1-.1 2.5-.1 4.3-.1h2.3c1.6.1 3.1.3 4.3.5 1.7.4 3.1 1 4.3 2 1.1.9 2 2.2 2.6 3.8.6 1.6 1 3.6 1.2 6h3.6V0h-1.1z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTextColourPicker);

/***/ }),

/***/ 32798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTimeTravel = function SvgTimeTravel(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 0C14.4 0 0 14.4 0 32s14.3 32 32 32 32-14.3 32-32C64 14.4 49.6 0 32 0zm4.3 21.2L35 22.9a52 52 0 0 1-3 3.6c-1-1.2-2-2.5-3-3.6l-1.4-1.7C24 16.8 24 11.1 24.3 8.1c4.9-1.6 10.4-1.6 15.2 0 .4 3 .4 8.7-3.2 13.1zm-18.6-9.9c.1 4 1.2 9.4 4.9 14L24 27c1.3 1.6 2.6 3.1 3.8 4.7-2.9 3.5-4.9 6.2-5.2 6.5-3.9 4.8-4.8 10.3-4.9 14.4A24.84 24.84 0 0 1 6.8 32c.1-8.3 4.1-16 10.9-20.7zm10 31c.4-.4 2.1-2.5 4.3-5.5 2.5 3.1 4.3 5.3 4.3 5.5 3.8 4.7 3.6 10.8 3.3 13.7-4.9 1.6-10.3 1.6-15.2 0-.3-2.9-.6-8.9 3.3-13.7zm18.6 10.4c0-4.2-1-9.6-4.9-14.4v-.1c-.4-.5-2.5-3.1-5.2-6.5 1.3-1.6 2.6-3.1 3.8-4.7l1.4-1.7c3.8-4.7 4.8-10 4.9-14C53.1 16 57.2 23.7 57.2 32c-.1 8.3-4.1 16-10.9 20.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTimeTravel);

/***/ }),

/***/ 51024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTorch = function SvgTorch(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M38.47 21.61 43 17.05a1.28 1.28 0 0 1 1.77 1.76l-4.57 4.57a1.28 1.28 0 0 1-1.77-1.77zM33 17.77l2.57-6.12a1 1 0 0 1 1.45-.31 1.36 1.36 0 0 1 .67 1.57L35.14 19a1 1 0 0 1-1.45.32 1.34 1.34 0 0 1-.69-1.55zm11.08 11.06 6.12-2.58a1 1 0 0 0 .32-1.45 1.34 1.34 0 0 0-1.52-.66l-6.12 2.57a1 1 0 0 0-.32 1.45 1.34 1.34 0 0 0 1.52.67zm-7.94-.55L34.86 27l-5.56-5.56-3.25 3.25-2.52 6.9L13.3 41.83a3 3 0 0 0 0 4.17l2.55 2.56a3 3 0 0 0 4.18 0l10-10 7.12-2.74 3.25-3.26zm-9.75 10.38-2.74 2.74a2.26 2.26 0 0 1-3.2-3.2l2.74-2.74a2.26 2.26 0 0 1 3.2 3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M25.89 38.27a1.63 1.63 0 0 1-2.3-2.27 1.63 1.63 0 1 1 2.3 2.31z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTorch);

/***/ }),

/***/ 93755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.6 58.1C14 61.3 17 64 20.3 64h23.5c3.3 0 6.3-2.7 6.7-5.9l4.9-42H8.7l4.9 42zm29.3-36.6c.1-1.1 1.1-1.9 2.2-1.8 1.1.1 1.9 1.1 1.8 2.2L44 55.6c-.1 1.1-1.1 1.9-2.2 1.8-1.1-.1-1.9-1.1-1.8-2.2l2.9-33.7zm-12.9.1c0-1.1.9-2 2-2a2 2 0 0 1 2 2v33.8a2 2 0 0 1-2 2 2 2 0 0 1-2-2V21.6zm-11-2c1.1-.1 2.1.7 2.2 1.8L24 55.2c.1 1.1-.7 2.1-1.8 2.2-1.1.1-2.1-.7-2.2-1.8l-2.9-33.8c-.1-1.1.8-2.1 1.9-2.2zM52.8 6.7H11.2c-2.9 0-4.9 1.7-4.9 4.4V13h51.4v-1.9c0-2.6-2.1-4.3-4.9-4.4zM38.5 3.9c0-.2.1-.4.1-.7v-.1c0-1.7-1.4-3.1-3.1-3.1h-7c-1.7 0-3.1 1.4-3.1 3.1v.2c0 .2 0 .5.1.7l13-.1z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTrash);

/***/ }),

/***/ 48080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M52.2 6.6c0-2.2.1-4.4.1-6.6H11.7c0 2.1 0 4.3.1 6.6H.5v1.9c0 11.2 1.9 23.8 16.3 32.1 2 1.1 4.2 1.9 6.4 2.5 1.9 1.8 4.2 3 6.8 3.4v2.9C30 55.3 25.3 60 19.5 60h-2.8v4h30.5v-4h-2.7C38.7 60 34 55.3 34 49.5v-2.9c2.6-.4 4.9-1.6 6.8-3.4 2.3-.5 4.4-1.3 6.4-2.5 14.3-8.3 16.3-20.9 16.3-32.2V6.6H52.2zm-47.7 4H12c.6 9.4 2.3 18.9 6.8 26.7C7 30.4 4.7 20.4 4.5 10.6zm40.7 26.6c4.5-7.8 6.2-17.3 6.8-26.7h7.5c-.2 9.9-2.5 19.9-14.3 26.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTrophy);

/***/ }),

/***/ 94686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M64 12.2c-2.4 1-4.9 1.8-7.5 2.1 2.7-1.6 4.8-4.2 5.8-7.3-2.5 1.5-5.3 2.6-8.3 3.2C51.5 7.6 48.1 6 44.3 6 37 6 31.2 11.9 31.2 19.1c0 1 .1 2 .3 3-10.9-.5-20.6-5.8-27-13.7-1.1 1.9-1.8 4.2-1.8 6.6 0 4.6 2.3 8.6 5.8 10.9-2.2-.1-4.2-.7-5.9-1.6v.2c0 6.4 4.5 11.7 10.5 12.9-1.1.3-2.3.5-3.5.5-.8 0-1.7-.1-2.5-.2 1.7 5.2 6.5 9 12.3 9.1-4.5 3.5-10.2 5.6-16.3 5.6-1.1 0-2.1-.1-3.1-.2C5.8 55.8 12.7 58 20.1 58c24.2 0 37.4-20 37.4-37.4v-1.7c2.5-1.8 4.7-4.1 6.5-6.7z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTwitter);

/***/ }),

/***/ 4773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M55.3 29.1c0 4.3-.5 8-1.4 11-.9 3-2.4 5.6-4.3 7.5-2 2-4.5 3.4-7.6 4.3-3.1.9-6.8 1.4-11.2 1.4-8.1 0-14-1.7-17.8-5.1-3.8-3.4-5.6-8.8-5.6-16.3v-15c0-2 0-3.6-.1-5-.1-1.3-.1-2.5-.2-3.4-.1-.9-.3-1.6-.4-2.2-.2-.6-.4-1.1-.7-1.5-.4-.7-1.1-1.1-2-1.4-.8-.2-2.2-.4-4-.4V0h27.3v3c-2.1 0-3.7.1-4.7.3-1 .2-1.8.7-2.3 1.3-.4.4-.6.9-.9 1.5a10 10 0 0 0-.5 2.3c-.1.9-.2 2.1-.3 3.4-.1 1.4-.1 3-.1 5V31c0 5.7 1.2 10 3.7 12.7 2.4 2.7 6.2 4.1 11.3 4.1 10.4 0 15.6-5.8 15.6-17.3V25c0-2.1 0-10.2-.1-11.7s-.2-2.8-.4-3.9-.4-1.9-.7-2.6c-.3-.7-.6-1.3-1-1.7-.7-.7-1.6-1.2-2.7-1.5-1.2-.4-2.7-.6-4.7-.6V0H64v3c-1.9 0-3.3.1-4.3.4-1 .3-1.8.8-2.3 1.5-.4.5-.7 1-1 1.8-.3.7-.5 1.6-.6 2.7-.2 1.1-.3 2.4-.3 3.9-.1 1.5-.1 9.6-.1 11.7v4.1zM0 61h64v3H0z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUnderline);

/***/ }),

/***/ 83624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgView = function SvgView(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 26a5.91 5.91 0 0 0 0 11.8A5.91 5.91 0 0 0 32 26z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M63.2 29.8S49.7 13.1 32 13.1C14.3 13 .8 29.8.8 29.8a3.35 3.35 0 0 0 0 4.4S14.7 51 31.8 51C49 51 63.2 34.2 63.2 34.2c1.1-1.2 1.1-3.2 0-4.4zM32 45.4c-7.3 0-13.3-6-13.3-13.4S24.6 18.6 32 18.6c7.3 0 13.3 6 13.3 13.4s-6 13.4-13.3 13.4z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgView);

/***/ }),

/***/ 85293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m.057 24 1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWhatsapp);

/***/ }),

/***/ 89862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgWorld = function SvgWorld(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zm27.3 35.5c-.1.5-.7.8-1.1.4-1.3-1.1-.3-2.2-.8-2.9-.6-.9-2.7-1.1-3.9-2.5-1.1-1.2-.2-1.5-.7-2.8-.3-.9-2.7-2.1-4.1-2-1.8.2-3.2 1.1-3.1 2.7.1 1.4 5.6.8 5.6 3.9 0 1.2-2.3 2.1-2.6 2.7-.3.7-.5 1.8-1 2.1s-1.9-.3-2.4 0-.5 1.6-.9 1.9c-.5.3-3.1.6-3.9 1.7-.8 1-.4 3.7-.9 4.5-.4.8-1.8 2.4-2 3.5-.3 1.6.4 3.5 0 4.6-.9 2.7-6.8 4.1-9.5 2.1-1.5-1.1-.2-3-1.2-4.3-.5-.6-1.1-.7-2.2-2-1-1.4.3-3.1-.5-4.4-1-1.6-7.6-3.5-8.7-5.9-.8-1.9-1-6.4-.4-8.2.4-1.3 2.7-1.9 3.6-2.6.8-.6 1.4-2.2 3.1-2.5 1.4-.2 2.9 1.3 3.6 1.7.7.5 2-.2 3.1.1 1.2.3 5.1 3.8 7 3.8s2.3-2.4 2.1-3.7-2.4-1.2-3.2-1.7c-.8-.6-1.9-2.8-3.2-2.8s-3.7 1.5-5.5 1.7c-1.7.2-2.8-1.1-2.9-2.7-.1-1.7 1.7-2.5 3-3 1.5-.6 7.9-1.1 11.6-3.7 1.1-.8 1-3.8 3.6-5.5 1.8-1.2 4.2-.6 5.6-.9.2 0 .4 0 .6.1 8.6 5.7 13.6 15.9 12.2 26.6zM29.5 4.6c.3 0 .5.1.6.3.8 1.1 1 3.3-.1 3.7-1.3.6-2.5.2-3.1.6-.8.5-.6 2.1-2.8 2.5-1.2.3-3.8-1.3-4.6-1.3s-3 .9-3.4 1.3c-.3.3-.8.4-1.3.4-.6 0-.9-.8-.5-1.2 4.1-3.5 9.4-5.8 15.2-6.3z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWorld);

/***/ }),

/***/ 11617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgZoo = function SvgZoo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.3 34.6c1.1-.1 2.2-.5 3.2-1.2 2.8-2.1 4.1-5.3 3.8-9.8-.2-1.7-.7-3.3-1.4-4.9-1.8-3.6-4.2-5.3-7.3-5.1-1.1.1-2.1.5-3.1 1.2C1.6 16.9.3 20.2.8 24.7c.1 1.7.5 3.3 1.2 4.8 1.7 3.6 4.1 5.3 7.3 5.1zM23.7 20.6c1 0 2-.3 2.9-.9 2.9-1.8 4.4-4.9 4.3-9.5 0-1.7-.3-3.2-.9-4.7C28.8 1.8 26.6 0 23.6 0c-1.1 0-2.1.3-2.9.9-3 1.8-4.5 4.9-4.5 9.5 0 1.7.3 3.3.9 5 1.5 3.5 3.7 5.2 6.6 5.2zM40.4 21.5c1.1.2 2.2.1 3.4-.2 3.3-1.2 5.5-3.9 6.6-8.2.7-3 .2-5.7-1.2-8.4-1.3-2.1-2.5-3.3-3.7-3.7-1.3-.1-2.5 0-3.8.5-3.2 1.1-5.4 3.8-6.4 8-.4 1.8-.5 3.5-.3 5.3.6 3.8 2.4 6.1 5.4 6.7zM63.3 28.5c-.1-3-1.1-5.5-2.9-7.5-1.8-1.9-3.5-2.9-5.2-2.9-1 0-2 .3-2.9.8-3.3 1.6-4.9 5-4.8 10.1 0 .7.1 1.4.2 2.1.8 4.8 3.5 7.2 8 7.2.6 0 1.2-.1 1.8-.2 4-1 5.9-4.2 5.8-9.6zM51.5 40.6l-1-.9c-.7-.6-1.1-.9-1.2-1s-.4-.4-1-.9-1-.9-1.1-1.1-.5-.5-1-1-1-.9-1.3-1.2-.7-.8-1.2-1.3-.9-1-1.3-1.5-.8-1-1.3-1.7c-.5-.6-1-1.3-1.5-2-1.9-2.4-4.6-3.7-8.3-3.8-3.4 0-6.2 1.5-8.4 4.5-2.8 4.1-6.2 7.8-10.2 11.3-.4.3-.8.7-1.3 1.2-4.1 3.7-6.1 7.3-6.1 10.8 0 1.3.2 2.7.6 4.1 1.5 5.2 4.6 7.8 9.2 7.7 2 0 4-.2 6.2-.5 6.1-.8 9.5-1.3 10.3-1.3 1.6 0 3.3.2 5.2.5 5.9 1 9.8 1.5 11.8 1.5 2.2 0 4.1-.7 5.9-2.1 2.9-2.3 4.4-5.4 4.3-9.3 0-.9-.1-1.7-.2-2.4-.6-2.8-2.9-6-7.1-9.6z"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgZoo);

/***/ }),

/***/ 77032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var getSize = function getSize(size) {
  switch (size) {
    case 'small':
      return '12px';

    case 'regular':
      return '18px';

    case 'large':
      return '24px';

    case 'x-large':
      return '37px';

    case 'xx-large':
      return '48px';

    default:
      return size;
  }
};

var SvgWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Icon__SvgWrapper",
  componentId: "sc-1w9lg11-0"
})(["filter:", ";position:", ";height:", ";width:", ";pointer-events:none;> svg{pointer-events:", ";opacity:", ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) ", ";height:", ";width:", ";fill:", ";}"], function (props) {
  return props.glow ? "drop-shadow(0 0 5px ".concat(props.color, ")") : props.filter || 'none';
}, function (props) {
  return props.position || 'relative';
}, function (props) {
  return getSize(props.size);
}, function (props) {
  return getSize(props.size);
}, function (props) {
  return props.clickThrough ? 'none' : '';
}, function (props) {
  return props.active === false ? 0 : 1;
}, function (props) {
  return props.flipped ? 'scale(-1)' : '';
}, function (props) {
  return getSize(props.size);
}, function (props) {
  return getSize(props.size);
}, function (props) {
  return props.color;
});

var Icon = function Icon(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      svg = _useState[0],
      setSvg = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    importSvg(props.name);
  }, []);

  var importSvg = /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(name) {
      var loadedSvg;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __webpack_require__(35558)("./".concat(props.name, ".svg"));

            case 3:
              loadedSvg = _context.sent;
              setSvg(loadedSvg["default"]);
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function importSvg(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SvgWrapper, _objectSpread(_objectSpread({}, props), {}, {
    children: svg || null
  }));
};

Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 'regular'
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 35558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./a-colour-picker.svg": 69251,
	"./align-center.svg": 71784,
	"./align-left.svg": 77846,
	"./align-right.svg": 13707,
	"./arrow-left.svg": 75651,
	"./arrow.svg": 98245,
	"./audio-pause.svg": 258,
	"./audio-play.svg": 42010,
	"./awards.svg": 86894,
	"./bell.svg": 76970,
	"./bold.svg": 76322,
	"./captain.svg": 55661,
	"./chat.svg": 88088,
	"./check.svg": 13176,
	"./collect.svg": 36025,
	"./comment.svg": 43750,
	"./cross.svg": 99118,
	"./draw.svg": 31233,
	"./edit.svg": 94329,
	"./facebook.svg": 71647,
	"./globe.svg": 27321,
	"./heart.svg": 40274,
	"./hero.svg": 29615,
	"./hexagon.svg": 69595,
	"./import-image.svg": 49136,
	"./inappropriate.svg": 5447,
	"./italic.svg": 14386,
	"./leagues.svg": 74793,
	"./left.svg": 92125,
	"./legend.svg": 26995,
	"./lock.svg": 38611,
	"./logo.svg": 45945,
	"./logout-2.svg": 90224,
	"./logout.svg": 65882,
	"./mail.svg": 98732,
	"./menu.svg": 25177,
	"./minus.svg": 68260,
	"./more.svg": 59029,
	"./music.svg": 73945,
	"./notifications.svg": 79359,
	"./orb-v2.svg": 18389,
	"./orb.svg": 73265,
	"./padlock.svg": 93413,
	"./pencil.svg": 83958,
	"./picture.svg": 29160,
	"./play.svg": 90455,
	"./plus.svg": 97053,
	"./print.svg": 58922,
	"./pro.svg": 10965,
	"./reading-light.svg": 34962,
	"./recruit.svg": 2656,
	"./referral.svg": 5733,
	"./refresh.svg": 92247,
	"./right.svg": 32941,
	"./school.svg": 25355,
	"./search.svg": 86573,
	"./settings.svg": 4296,
	"./sfx.svg": 93073,
	"./shield.svg": 18958,
	"./star.svg": 78545,
	"./text-colour-picker.svg": 68760,
	"./time-travel.svg": 32798,
	"./torch.svg": 51024,
	"./trash.svg": 93755,
	"./trophy.svg": 48080,
	"./twitter.svg": 94686,
	"./underline.svg": 4773,
	"./view.svg": 83624,
	"./whatsapp.svg": 85293,
	"./world.svg": 89862,
	"./zoo.svg": 11617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35558;

/***/ })

}]);